/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable import/order */

import gql from 'graphql-tag';
import { Observable } from 'rxjs';
import { CommandResult } from 'src/util/graphql/command-result';
import {
  AddAccessibleItem,
  AddAccessibleItemMutation,
  AddAccessibleItemMutationVariables,
  DeleteAccessibleItem,
  DeleteAccessibleItemMutation,
  DeleteAccessibleItemMutationVariables,
  UpdateAccessibleItem,
  UpdateAccessibleItemMutation,
  UpdateAccessibleItemMutationVariables,
  AddAgency,
  AddAgencyMutation,
  AddAgencyMutationVariables,
  DeleteAgency,
  DeleteAgencyMutation,
  DeleteAgencyMutationVariables,
  UpdateAgency,
  UpdateAgencyMutation,
  UpdateAgencyMutationVariables,
  AddAgencyLocation,
  AddAgencyLocationMutation,
  AddAgencyLocationMutationVariables,
  DeleteAgencyLocation,
  DeleteAgencyLocationMutation,
  DeleteAgencyLocationMutationVariables,
  LookupAgencyLocationByPhoneNumber,
  LookupAgencyLocationByPhoneNumberMutation,
  LookupAgencyLocationByPhoneNumberMutationVariables,
  UpdateAgencyLocation,
  UpdateAgencyLocationMutation,
  UpdateAgencyLocationMutationVariables,
  AddAirport,
  AddAirportMutation,
  AddAirportMutationVariables,
  DeleteAirport,
  DeleteAirportMutation,
  DeleteAirportMutationVariables,
  UpdateAirport,
  UpdateAirportMutation,
  UpdateAirportMutationVariables,
  DeleteAttachment,
  DeleteAttachmentMutation,
  DeleteAttachmentMutationVariables,
  GenerateAttachmentUrl,
  GenerateAttachmentUrlMutation,
  GenerateAttachmentUrlMutationVariables,
  AddBaseControlZone,
  AddBaseControlZoneMutation,
  AddBaseControlZoneMutationVariables,
  DeleteBaseControlZone,
  DeleteBaseControlZoneMutation,
  DeleteBaseControlZoneMutationVariables,
  UpdateBaseControlZone,
  UpdateBaseControlZoneMutation,
  UpdateBaseControlZoneMutationVariables,
  AddBaseMedicalControlContact,
  AddBaseMedicalControlContactMutation,
  AddBaseMedicalControlContactMutationVariables,
  DeleteBaseMedicalControlContact,
  DeleteBaseMedicalControlContactMutation,
  DeleteBaseMedicalControlContactMutationVariables,
  UpdateBaseMedicalControlContact,
  UpdateBaseMedicalControlContactMutation,
  UpdateBaseMedicalControlContactMutationVariables,
  AddBase,
  AddBaseMutation,
  AddBaseMutationVariables,
  AddBaseAdditionalCompany,
  AddBaseAdditionalCompanyMutation,
  AddBaseAdditionalCompanyMutationVariables,
  DeleteBase,
  DeleteBaseMutation,
  DeleteBaseMutationVariables,
  RemoveBaseAdditionalCompany,
  RemoveBaseAdditionalCompanyMutation,
  RemoveBaseAdditionalCompanyMutationVariables,
  UpdateBase,
  UpdateBaseMutation,
  UpdateBaseMutationVariables,
  UpdateBaseCustomIdentifiers,
  UpdateBaseCustomIdentifiersMutation,
  UpdateBaseCustomIdentifiersMutationVariables,
  AddCapability,
  AddCapabilityMutation,
  AddCapabilityMutationVariables,
  DeleteCapability,
  DeleteCapabilityMutation,
  DeleteCapabilityMutationVariables,
  UpdateCapability,
  UpdateCapabilityMutation,
  UpdateCapabilityMutationVariables,
  AddCommunicationCenter,
  AddCommunicationCenterMutation,
  AddCommunicationCenterMutationVariables,
  DeleteCommunicationCenter,
  DeleteCommunicationCenterMutation,
  DeleteCommunicationCenterMutationVariables,
  UpdateCommunicationCenter,
  UpdateCommunicationCenterMutation,
  UpdateCommunicationCenterMutationVariables,
  AddCommunicationCenterTransportOfferOption,
  AddCommunicationCenterTransportOfferOptionMutation,
  AddCommunicationCenterTransportOfferOptionMutationVariables,
  DeleteCommunicationCenterTransportOfferOption,
  DeleteCommunicationCenterTransportOfferOptionMutation,
  DeleteCommunicationCenterTransportOfferOptionMutationVariables,
  UpdateCommunicationCenterTransportOfferOption,
  UpdateCommunicationCenterTransportOfferOptionMutation,
  UpdateCommunicationCenterTransportOfferOptionMutationVariables,
  AddCompany,
  AddCompanyMutation,
  AddCompanyMutationVariables,
  DeleteCompany,
  DeleteCompanyMutation,
  DeleteCompanyMutationVariables,
  UpdateCompany,
  UpdateCompanyMutation,
  UpdateCompanyMutationVariables,
  AddCompleteFlightInstance,
  AddCompleteFlightInstanceMutation,
  AddCompleteFlightInstanceMutationVariables,
  DeleteCompleteFlightInstance,
  DeleteCompleteFlightInstanceMutation,
  DeleteCompleteFlightInstanceMutationVariables,
  UpdateCompleteFlightInstance,
  UpdateCompleteFlightInstanceMutation,
  UpdateCompleteFlightInstanceMutationVariables,
  AddControlZone,
  AddControlZoneMutation,
  AddControlZoneMutationVariables,
  DeleteControlZone,
  DeleteControlZoneMutation,
  DeleteControlZoneMutationVariables,
  UpdateControlZone,
  UpdateControlZoneMutation,
  UpdateControlZoneMutationVariables,
  AddDepartment,
  AddDepartmentMutation,
  AddDepartmentMutationVariables,
  DeleteDepartment,
  DeleteDepartmentMutation,
  DeleteDepartmentMutationVariables,
  UpdateDepartment,
  UpdateDepartmentMutation,
  UpdateDepartmentMutationVariables,
  AddEntityCapability,
  AddEntityCapabilityMutation,
  AddEntityCapabilityMutationVariables,
  DeleteEntityCapability,
  DeleteEntityCapabilityMutation,
  DeleteEntityCapabilityMutationVariables,
  AddExternalReference,
  AddExternalReferenceMutation,
  AddExternalReferenceMutationVariables,
  DeleteExternalReference,
  DeleteExternalReferenceMutation,
  DeleteExternalReferenceMutationVariables,
  UndeleteExternalReference,
  UndeleteExternalReferenceMutation,
  UndeleteExternalReferenceMutationVariables,
  UpdateExternalReference,
  UpdateExternalReferenceMutation,
  UpdateExternalReferenceMutationVariables,
  AddFbo,
  AddFboMutation,
  AddFboMutationVariables,
  DeleteFbo,
  DeleteFboMutation,
  DeleteFboMutationVariables,
  UpdateFbo,
  UpdateFboMutation,
  UpdateFboMutationVariables,
  AddFuelTank,
  AddFuelTankMutation,
  AddFuelTankMutationVariables,
  DeleteFuelTank,
  DeleteFuelTankMutation,
  DeleteFuelTankMutationVariables,
  UpdateFuelTank,
  UpdateFuelTankMutation,
  UpdateFuelTankMutationVariables,
  AddLocation,
  AddLocationMutation,
  AddLocationMutationVariables,
  DeleteLocation,
  DeleteLocationMutation,
  DeleteLocationMutationVariables,
  RefreshLocationsFromGMRWorkday,
  RefreshLocationsFromGMRWorkdayMutation,
  RefreshLocationsFromGMRWorkdayMutationVariables,
  UpdateLocation,
  UpdateLocationMutation,
  UpdateLocationMutationVariables,
  AddMaintenanceFacility,
  AddMaintenanceFacilityMutation,
  AddMaintenanceFacilityMutationVariables,
  DeleteMaintenanceFacility,
  DeleteMaintenanceFacilityMutation,
  DeleteMaintenanceFacilityMutationVariables,
  UpdateMaintenanceFacility,
  UpdateMaintenanceFacilityMutation,
  UpdateMaintenanceFacilityMutationVariables,
  AddMedicalFacility,
  AddMedicalFacilityMutation,
  AddMedicalFacilityMutationVariables,
  ApproveMedicalFacility,
  ApproveMedicalFacilityMutation,
  ApproveMedicalFacilityMutationVariables,
  ArchiveMedicalFacility,
  ArchiveMedicalFacilityMutation,
  ArchiveMedicalFacilityMutationVariables,
  ClearPendingArchiveMedicalFacility,
  ClearPendingArchiveMedicalFacilityMutation,
  ClearPendingArchiveMedicalFacilityMutationVariables,
  DeleteMedicalFacility,
  DeleteMedicalFacilityMutation,
  DeleteMedicalFacilityMutationVariables,
  MergeMedicalFacilities,
  MergeMedicalFacilitiesMutation,
  MergeMedicalFacilitiesMutationVariables,
  SubmitMedicalFacilityForApproval,
  SubmitMedicalFacilityForApprovalMutation,
  SubmitMedicalFacilityForApprovalMutationVariables,
  UnmarkMedicalFacilityAsDuplicate,
  UnmarkMedicalFacilityAsDuplicateMutation,
  UnmarkMedicalFacilityAsDuplicateMutationVariables,
  UpdateMedicalFacility,
  UpdateMedicalFacilityMutation,
  UpdateMedicalFacilityMutationVariables,
  UpdateMedicalFacilityCustomIdentifiers,
  UpdateMedicalFacilityCustomIdentifiersMutation,
  UpdateMedicalFacilityCustomIdentifiersMutationVariables,
  AddMedicalFacilityContact,
  AddMedicalFacilityContactMutation,
  AddMedicalFacilityContactMutationVariables,
  DeleteMedicalFacilityContact,
  DeleteMedicalFacilityContactMutation,
  DeleteMedicalFacilityContactMutationVariables,
  UpdateMedicalFacilityContact,
  UpdateMedicalFacilityContactMutation,
  UpdateMedicalFacilityContactMutationVariables,
  AddMedicalFacilityPhysician,
  AddMedicalFacilityPhysicianMutation,
  AddMedicalFacilityPhysicianMutationVariables,
  DeleteMedicalFacilityPhysician,
  DeleteMedicalFacilityPhysicianMutation,
  DeleteMedicalFacilityPhysicianMutationVariables,
  UpdateMedicalFacilityPhysician,
  UpdateMedicalFacilityPhysicianMutation,
  UpdateMedicalFacilityPhysicianMutationVariables,
  AddMedicalFacilityUnit,
  AddMedicalFacilityUnitMutation,
  AddMedicalFacilityUnitMutationVariables,
  DeleteMedicalFacilityUnit,
  DeleteMedicalFacilityUnitMutation,
  DeleteMedicalFacilityUnitMutationVariables,
  UpdateMedicalFacilityUnit,
  UpdateMedicalFacilityUnitMutation,
  UpdateMedicalFacilityUnitMutationVariables,
  AddOutOfServiceQARReason,
  AddOutOfServiceQARReasonMutation,
  AddOutOfServiceQARReasonMutationVariables,
  DeleteOutOfServiceQARReason,
  DeleteOutOfServiceQARReasonMutation,
  DeleteOutOfServiceQARReasonMutationVariables,
  UpdateOutOfServiceQARReason,
  UpdateOutOfServiceQARReasonMutation,
  UpdateOutOfServiceQARReasonMutationVariables,
  AddOutOfComplianceCrewMember,
  AddOutOfComplianceCrewMemberMutation,
  AddOutOfComplianceCrewMemberMutationVariables,
  AddPerson,
  AddPersonMutation,
  AddPersonMutationVariables,
  AddPersonAdditionalCompany,
  AddPersonAdditionalCompanyMutation,
  AddPersonAdditionalCompanyMutationVariables,
  AuthorizeClientSyncAccess,
  AuthorizeClientSyncAccessMutation,
  AuthorizeClientSyncAccessMutationVariables,
  DeletePerson,
  DeletePersonMutation,
  DeletePersonMutationVariables,
  GrantClientSyncAccess,
  GrantClientSyncAccessMutation,
  GrantClientSyncAccessMutationVariables,
  RefreshPeopleFromGMRWorkdayV2,
  RefreshPeopleFromGMRWorkdayV2Mutation,
  RefreshPeopleFromGMRWorkdayV2MutationVariables,
  RemoveCrewMemberFromOutOfCompliance,
  RemoveCrewMemberFromOutOfComplianceMutation,
  RemoveCrewMemberFromOutOfComplianceMutationVariables,
  RemovePersonAdditionalCompany,
  RemovePersonAdditionalCompanyMutation,
  RemovePersonAdditionalCompanyMutationVariables,
  ResetPassword,
  ResetPasswordMutation,
  ResetPasswordMutationVariables,
  SetRoleScope,
  SetRoleScopeMutation,
  SetRoleScopeMutationVariables,
  UpdateOutOfComplianceCrewMember,
  UpdateOutOfComplianceCrewMemberMutation,
  UpdateOutOfComplianceCrewMemberMutationVariables,
  UpdatePerson,
  UpdatePersonMutation,
  UpdatePersonMutationVariables,
  UpdateTcsRealtimeTrackingTab,
  UpdateTcsRealtimeTrackingTabMutation,
  UpdateTcsRealtimeTrackingTabMutationVariables,
  AddPhysician,
  AddPhysicianMutation,
  AddPhysicianMutationVariables,
  DeletePhysician,
  DeletePhysicianMutation,
  DeletePhysicianMutationVariables,
  UpdatePhysician,
  UpdatePhysicianMutation,
  UpdatePhysicianMutationVariables,
  AddProgramBase,
  AddProgramBaseMutation,
  AddProgramBaseMutationVariables,
  DeleteProgramBase,
  DeleteProgramBaseMutation,
  DeleteProgramBaseMutationVariables,
  UpdateProgramBase,
  UpdateProgramBaseMutation,
  UpdateProgramBaseMutationVariables,
  AddProgram,
  AddProgramMutation,
  AddProgramMutationVariables,
  DeleteProgram,
  DeleteProgramMutation,
  DeleteProgramMutationVariables,
  UpdateProgram,
  UpdateProgramMutation,
  UpdateProgramMutationVariables,
  AddRegionBase,
  AddRegionBaseMutation,
  AddRegionBaseMutationVariables,
  DeleteRegionBase,
  DeleteRegionBaseMutation,
  DeleteRegionBaseMutationVariables,
  UpdateRegionBase,
  UpdateRegionBaseMutation,
  UpdateRegionBaseMutationVariables,
  AddRegionGroup,
  AddRegionGroupMutation,
  AddRegionGroupMutationVariables,
  DeleteRegionGroup,
  DeleteRegionGroupMutation,
  DeleteRegionGroupMutationVariables,
  UpdateRegionGroup,
  UpdateRegionGroupMutation,
  UpdateRegionGroupMutationVariables,
  AddRegion,
  AddRegionMutation,
  AddRegionMutationVariables,
  AddTransferCenterRegion,
  AddTransferCenterRegionMutation,
  AddTransferCenterRegionMutationVariables,
  DeleteRegion,
  DeleteRegionMutation,
  DeleteRegionMutationVariables,
  UpdateRegion,
  UpdateRegionMutation,
  UpdateRegionMutationVariables,
  AddReleaseNote,
  AddReleaseNoteMutation,
  AddReleaseNoteMutationVariables,
  DeleteReleaseNote,
  DeleteReleaseNoteMutation,
  DeleteReleaseNoteMutationVariables,
  UpdateReleaseNote,
  UpdateReleaseNoteMutation,
  UpdateReleaseNoteMutationVariables,
  AddExistingSpecialtyTeamMember,
  AddExistingSpecialtyTeamMemberMutation,
  AddExistingSpecialtyTeamMemberMutationVariables,
  AddSpecialtyTeamMember,
  AddSpecialtyTeamMemberMutation,
  AddSpecialtyTeamMemberMutationVariables,
  DeleteSpecialtyTeamMember,
  DeleteSpecialtyTeamMemberMutation,
  DeleteSpecialtyTeamMemberMutationVariables,
  UpdateSpecialtyTeamMember,
  UpdateSpecialtyTeamMemberMutation,
  UpdateSpecialtyTeamMemberMutationVariables,
  AddSpecialtyTeam,
  AddSpecialtyTeamMutation,
  AddSpecialtyTeamMutationVariables,
  DeleteSpecialtyTeam,
  DeleteSpecialtyTeamMutation,
  DeleteSpecialtyTeamMutationVariables,
  UpdateSpecialtyTeam,
  UpdateSpecialtyTeamMutation,
  UpdateSpecialtyTeamMutationVariables,
  AddState,
  AddStateMutation,
  AddStateMutationVariables,
  DeleteState,
  DeleteStateMutation,
  DeleteStateMutationVariables,
  UpdateState,
  UpdateStateMutation,
  UpdateStateMutationVariables,
  AddSupportRequest,
  AddSupportRequestMutation,
  AddSupportRequestMutationVariables,
  DeleteSupportRequest,
  DeleteSupportRequestMutation,
  DeleteSupportRequestMutationVariables,
  SetSupportRequestState,
  SetSupportRequestStateMutation,
  SetSupportRequestStateMutationVariables,
  SubmitSupportRequest,
  SubmitSupportRequestMutation,
  SubmitSupportRequestMutationVariables,
  UpdateSupportRequest,
  UpdateSupportRequestMutation,
  UpdateSupportRequestMutationVariables,
  UpdateSupportRequestEmailSent,
  UpdateSupportRequestEmailSentMutation,
  UpdateSupportRequestEmailSentMutationVariables,
  AddTimezone,
  AddTimezoneMutation,
  AddTimezoneMutationVariables,
  DeleteTimezone,
  DeleteTimezoneMutation,
  DeleteTimezoneMutationVariables,
  UpdateTimezone,
  UpdateTimezoneMutation,
  UpdateTimezoneMutationVariables,
  AddTransferCenter,
  AddTransferCenterMutation,
  AddTransferCenterMutationVariables,
  DeleteTransferCenter,
  DeleteTransferCenterMutation,
  DeleteTransferCenterMutationVariables,
  UpdateTransferCenter,
  UpdateTransferCenterMutation,
  UpdateTransferCenterMutationVariables,
  AddPreApprovedTrmUser,
  AddPreApprovedTrmUserMutation,
  AddPreApprovedTrmUserMutationVariables,
  ApproveTrmUser,
  ApproveTrmUserMutation,
  ApproveTrmUserMutationVariables,
  DeactivateTrmUser,
  DeactivateTrmUserMutation,
  DeactivateTrmUserMutationVariables,
  DeleteTrmUser,
  DeleteTrmUserMutation,
  DeleteTrmUserMutationVariables,
  DenyTrmUser,
  DenyTrmUserMutation,
  DenyTrmUserMutationVariables,
  RegisterTrmUser,
  RegisterTrmUserMutation,
  RegisterTrmUserMutationVariables,
  UpdateTrmUser,
  UpdateTrmUserMutation,
  UpdateTrmUserMutationVariables,
  AddVehicleConfigurationClass,
  AddVehicleConfigurationClassMutation,
  AddVehicleConfigurationClassMutationVariables,
  DeleteVehicleConfigurationClass,
  DeleteVehicleConfigurationClassMutation,
  DeleteVehicleConfigurationClassMutationVariables,
  UpdateVehicleConfigurationClass,
  UpdateVehicleConfigurationClassMutation,
  UpdateVehicleConfigurationClassMutationVariables,
  AddVehicleControlZone,
  AddVehicleControlZoneMutation,
  AddVehicleControlZoneMutationVariables,
  DeleteVehicleControlZone,
  DeleteVehicleControlZoneMutation,
  DeleteVehicleControlZoneMutationVariables,
  UpdateVehicleControlZone,
  UpdateVehicleControlZoneMutation,
  UpdateVehicleControlZoneMutationVariables,
  AddVehicleMaintenance,
  AddVehicleMaintenanceMutation,
  AddVehicleMaintenanceMutationVariables,
  DeleteVehicleMaintenance,
  DeleteVehicleMaintenanceMutation,
  DeleteVehicleMaintenanceMutationVariables,
  UpdateVehicleMaintenance,
  UpdateVehicleMaintenanceMutation,
  UpdateVehicleMaintenanceMutationVariables,
  UpsertVehicleMaintenanceParameters,
  UpsertVehicleMaintenanceParametersMutation,
  UpsertVehicleMaintenanceParametersMutationVariables,
  AddVehicleMake,
  AddVehicleMakeMutation,
  AddVehicleMakeMutationVariables,
  DeleteVehicleMake,
  DeleteVehicleMakeMutation,
  DeleteVehicleMakeMutationVariables,
  UpdateVehicleMake,
  UpdateVehicleMakeMutation,
  UpdateVehicleMakeMutationVariables,
  AddVehicleModel,
  AddVehicleModelMutation,
  AddVehicleModelMutationVariables,
  DeleteVehicleModel,
  DeleteVehicleModelMutation,
  DeleteVehicleModelMutationVariables,
  UpdateVehicleModel,
  UpdateVehicleModelMutation,
  UpdateVehicleModelMutationVariables,
  AddVehicle,
  AddVehicleMutation,
  AddVehicleMutationVariables,
  ChangeVehicleFlightLogProcess,
  ChangeVehicleFlightLogProcessMutation,
  ChangeVehicleFlightLogProcessMutationVariables,
  DeleteVehicle,
  DeleteVehicleMutation,
  DeleteVehicleMutationVariables,
  EnsureThirdPartyVehicleAndUnit,
  EnsureThirdPartyVehicleAndUnitMutation,
  EnsureThirdPartyVehicleAndUnitMutationVariables,
  HideVehicle,
  HideVehicleMutation,
  HideVehicleMutationVariables,
  SetVehicleControlZoneId,
  SetVehicleControlZoneIdMutation,
  SetVehicleControlZoneIdMutationVariables,
  UndeleteVehicle,
  UndeleteVehicleMutation,
  UndeleteVehicleMutationVariables,
  UnhideVehicle,
  UnhideVehicleMutation,
  UnhideVehicleMutationVariables,
  UpdateVehicle,
  UpdateVehicleMutation,
  UpdateVehicleMutationVariables,
  AddVehicleStateInspection,
  AddVehicleStateInspectionMutation,
  AddVehicleStateInspectionMutationVariables,
  DeleteVehicleStateInspection,
  DeleteVehicleStateInspectionMutation,
  DeleteVehicleStateInspectionMutationVariables,
  UpdateVehicleStateInspection,
  UpdateVehicleStateInspectionMutation,
  UpdateVehicleStateInspectionMutationVariables,
} from '../graphql-operation-types.generated';
import {
  GraphqlMutationExecutorService,
  GraphQLMutationExecutionOptions,
} from '../graphql-mutation-executor.service';

export enum OrgCommand {
  AddAccessibleItem = 'AddAccessibleItem',
  DeleteAccessibleItem = 'DeleteAccessibleItem',
  UpdateAccessibleItem = 'UpdateAccessibleItem',
  AddAgency = 'AddAgency',
  DeleteAgency = 'DeleteAgency',
  UpdateAgency = 'UpdateAgency',
  AddAgencyLocation = 'AddAgencyLocation',
  DeleteAgencyLocation = 'DeleteAgencyLocation',
  LookupAgencyLocationByPhoneNumber = 'LookupAgencyLocationByPhoneNumber',
  UpdateAgencyLocation = 'UpdateAgencyLocation',
  AddAirport = 'AddAirport',
  DeleteAirport = 'DeleteAirport',
  UpdateAirport = 'UpdateAirport',
  DeleteAttachment = 'DeleteAttachment',
  GenerateAttachmentUrl = 'GenerateAttachmentUrl',
  AddBaseControlZone = 'AddBaseControlZone',
  DeleteBaseControlZone = 'DeleteBaseControlZone',
  UpdateBaseControlZone = 'UpdateBaseControlZone',
  AddBaseMedicalControlContact = 'AddBaseMedicalControlContact',
  DeleteBaseMedicalControlContact = 'DeleteBaseMedicalControlContact',
  UpdateBaseMedicalControlContact = 'UpdateBaseMedicalControlContact',
  AddBase = 'AddBase',
  AddBaseAdditionalCompany = 'AddBaseAdditionalCompany',
  DeleteBase = 'DeleteBase',
  RemoveBaseAdditionalCompany = 'RemoveBaseAdditionalCompany',
  UpdateBase = 'UpdateBase',
  UpdateBaseCustomIdentifiers = 'UpdateBaseCustomIdentifiers',
  AddCapability = 'AddCapability',
  DeleteCapability = 'DeleteCapability',
  UpdateCapability = 'UpdateCapability',
  AddCommunicationCenter = 'AddCommunicationCenter',
  DeleteCommunicationCenter = 'DeleteCommunicationCenter',
  UpdateCommunicationCenter = 'UpdateCommunicationCenter',
  AddCommunicationCenterTransportOfferOption = 'AddCommunicationCenterTransportOfferOption',
  DeleteCommunicationCenterTransportOfferOption = 'DeleteCommunicationCenterTransportOfferOption',
  UpdateCommunicationCenterTransportOfferOption = 'UpdateCommunicationCenterTransportOfferOption',
  AddCompany = 'AddCompany',
  DeleteCompany = 'DeleteCompany',
  UpdateCompany = 'UpdateCompany',
  AddCompleteFlightInstance = 'AddCompleteFlightInstance',
  DeleteCompleteFlightInstance = 'DeleteCompleteFlightInstance',
  UpdateCompleteFlightInstance = 'UpdateCompleteFlightInstance',
  AddControlZone = 'AddControlZone',
  DeleteControlZone = 'DeleteControlZone',
  UpdateControlZone = 'UpdateControlZone',
  AddDepartment = 'AddDepartment',
  DeleteDepartment = 'DeleteDepartment',
  UpdateDepartment = 'UpdateDepartment',
  AddEntityCapability = 'AddEntityCapability',
  DeleteEntityCapability = 'DeleteEntityCapability',
  AddExternalReference = 'AddExternalReference',
  DeleteExternalReference = 'DeleteExternalReference',
  UndeleteExternalReference = 'UndeleteExternalReference',
  UpdateExternalReference = 'UpdateExternalReference',
  AddFbo = 'AddFbo',
  DeleteFbo = 'DeleteFbo',
  UpdateFbo = 'UpdateFbo',
  AddFuelTank = 'AddFuelTank',
  DeleteFuelTank = 'DeleteFuelTank',
  UpdateFuelTank = 'UpdateFuelTank',
  AddLocation = 'AddLocation',
  DeleteLocation = 'DeleteLocation',
  RefreshLocationsFromGMRWorkday = 'RefreshLocationsFromGMRWorkday',
  UpdateLocation = 'UpdateLocation',
  AddMaintenanceFacility = 'AddMaintenanceFacility',
  DeleteMaintenanceFacility = 'DeleteMaintenanceFacility',
  UpdateMaintenanceFacility = 'UpdateMaintenanceFacility',
  AddMedicalFacility = 'AddMedicalFacility',
  ApproveMedicalFacility = 'ApproveMedicalFacility',
  ArchiveMedicalFacility = 'ArchiveMedicalFacility',
  ClearPendingArchiveMedicalFacility = 'ClearPendingArchiveMedicalFacility',
  DeleteMedicalFacility = 'DeleteMedicalFacility',
  MergeMedicalFacilities = 'MergeMedicalFacilities',
  SubmitMedicalFacilityForApproval = 'SubmitMedicalFacilityForApproval',
  UnmarkMedicalFacilityAsDuplicate = 'UnmarkMedicalFacilityAsDuplicate',
  UpdateMedicalFacility = 'UpdateMedicalFacility',
  UpdateMedicalFacilityCustomIdentifiers = 'UpdateMedicalFacilityCustomIdentifiers',
  AddMedicalFacilityContact = 'AddMedicalFacilityContact',
  DeleteMedicalFacilityContact = 'DeleteMedicalFacilityContact',
  UpdateMedicalFacilityContact = 'UpdateMedicalFacilityContact',
  AddMedicalFacilityPhysician = 'AddMedicalFacilityPhysician',
  DeleteMedicalFacilityPhysician = 'DeleteMedicalFacilityPhysician',
  UpdateMedicalFacilityPhysician = 'UpdateMedicalFacilityPhysician',
  AddMedicalFacilityUnit = 'AddMedicalFacilityUnit',
  DeleteMedicalFacilityUnit = 'DeleteMedicalFacilityUnit',
  UpdateMedicalFacilityUnit = 'UpdateMedicalFacilityUnit',
  AddOutOfServiceQARReason = 'AddOutOfServiceQARReason',
  DeleteOutOfServiceQARReason = 'DeleteOutOfServiceQARReason',
  UpdateOutOfServiceQARReason = 'UpdateOutOfServiceQARReason',
  AddOutOfComplianceCrewMember = 'AddOutOfComplianceCrewMember',
  AddPerson = 'AddPerson',
  AddPersonAdditionalCompany = 'AddPersonAdditionalCompany',
  AuthorizeClientSyncAccess = 'AuthorizeClientSyncAccess',
  DeletePerson = 'DeletePerson',
  GrantClientSyncAccess = 'GrantClientSyncAccess',
  RefreshPeopleFromGMRWorkdayV2 = 'RefreshPeopleFromGMRWorkdayV2',
  RemoveCrewMemberFromOutOfCompliance = 'RemoveCrewMemberFromOutOfCompliance',
  RemovePersonAdditionalCompany = 'RemovePersonAdditionalCompany',
  ResetPassword = 'ResetPassword',
  SetRoleScope = 'SetRoleScope',
  UpdateOutOfComplianceCrewMember = 'UpdateOutOfComplianceCrewMember',
  UpdatePerson = 'UpdatePerson',
  UpdateTcsRealtimeTrackingTab = 'UpdateTcsRealtimeTrackingTab',
  AddPhysician = 'AddPhysician',
  DeletePhysician = 'DeletePhysician',
  UpdatePhysician = 'UpdatePhysician',
  AddProgramBase = 'AddProgramBase',
  DeleteProgramBase = 'DeleteProgramBase',
  UpdateProgramBase = 'UpdateProgramBase',
  AddProgram = 'AddProgram',
  DeleteProgram = 'DeleteProgram',
  UpdateProgram = 'UpdateProgram',
  AddRegionBase = 'AddRegionBase',
  DeleteRegionBase = 'DeleteRegionBase',
  UpdateRegionBase = 'UpdateRegionBase',
  AddRegionGroup = 'AddRegionGroup',
  DeleteRegionGroup = 'DeleteRegionGroup',
  UpdateRegionGroup = 'UpdateRegionGroup',
  AddRegion = 'AddRegion',
  AddTransferCenterRegion = 'AddTransferCenterRegion',
  DeleteRegion = 'DeleteRegion',
  UpdateRegion = 'UpdateRegion',
  AddReleaseNote = 'AddReleaseNote',
  DeleteReleaseNote = 'DeleteReleaseNote',
  UpdateReleaseNote = 'UpdateReleaseNote',
  AddExistingSpecialtyTeamMember = 'AddExistingSpecialtyTeamMember',
  AddSpecialtyTeamMember = 'AddSpecialtyTeamMember',
  DeleteSpecialtyTeamMember = 'DeleteSpecialtyTeamMember',
  UpdateSpecialtyTeamMember = 'UpdateSpecialtyTeamMember',
  AddSpecialtyTeam = 'AddSpecialtyTeam',
  DeleteSpecialtyTeam = 'DeleteSpecialtyTeam',
  UpdateSpecialtyTeam = 'UpdateSpecialtyTeam',
  AddState = 'AddState',
  DeleteState = 'DeleteState',
  UpdateState = 'UpdateState',
  AddSupportRequest = 'AddSupportRequest',
  DeleteSupportRequest = 'DeleteSupportRequest',
  SetSupportRequestState = 'SetSupportRequestState',
  SubmitSupportRequest = 'SubmitSupportRequest',
  UpdateSupportRequest = 'UpdateSupportRequest',
  UpdateSupportRequestEmailSent = 'UpdateSupportRequestEmailSent',
  AddTimezone = 'AddTimezone',
  DeleteTimezone = 'DeleteTimezone',
  UpdateTimezone = 'UpdateTimezone',
  AddTransferCenter = 'AddTransferCenter',
  DeleteTransferCenter = 'DeleteTransferCenter',
  UpdateTransferCenter = 'UpdateTransferCenter',
  AddPreApprovedTrmUser = 'AddPreApprovedTrmUser',
  ApproveTrmUser = 'ApproveTrmUser',
  DeactivateTrmUser = 'DeactivateTrmUser',
  DeleteTrmUser = 'DeleteTrmUser',
  DenyTrmUser = 'DenyTrmUser',
  RegisterTrmUser = 'RegisterTrmUser',
  UpdateTrmUser = 'UpdateTrmUser',
  AddVehicleConfigurationClass = 'AddVehicleConfigurationClass',
  DeleteVehicleConfigurationClass = 'DeleteVehicleConfigurationClass',
  UpdateVehicleConfigurationClass = 'UpdateVehicleConfigurationClass',
  AddVehicleControlZone = 'AddVehicleControlZone',
  DeleteVehicleControlZone = 'DeleteVehicleControlZone',
  UpdateVehicleControlZone = 'UpdateVehicleControlZone',
  AddVehicleMaintenance = 'AddVehicleMaintenance',
  DeleteVehicleMaintenance = 'DeleteVehicleMaintenance',
  UpdateVehicleMaintenance = 'UpdateVehicleMaintenance',
  UpsertVehicleMaintenanceParameters = 'UpsertVehicleMaintenanceParameters',
  AddVehicleMake = 'AddVehicleMake',
  DeleteVehicleMake = 'DeleteVehicleMake',
  UpdateVehicleMake = 'UpdateVehicleMake',
  AddVehicleModel = 'AddVehicleModel',
  DeleteVehicleModel = 'DeleteVehicleModel',
  UpdateVehicleModel = 'UpdateVehicleModel',
  AddVehicle = 'AddVehicle',
  ChangeVehicleFlightLogProcess = 'ChangeVehicleFlightLogProcess',
  DeleteVehicle = 'DeleteVehicle',
  EnsureThirdPartyVehicleAndUnit = 'EnsureThirdPartyVehicleAndUnit',
  HideVehicle = 'HideVehicle',
  SetVehicleControlZoneId = 'SetVehicleControlZoneId',
  UndeleteVehicle = 'UndeleteVehicle',
  UnhideVehicle = 'UnhideVehicle',
  UpdateVehicle = 'UpdateVehicle',
  AddVehicleStateInspection = 'AddVehicleStateInspection',
  DeleteVehicleStateInspection = 'DeleteVehicleStateInspection',
  UpdateVehicleStateInspection = 'UpdateVehicleStateInspection',
}

export enum OrgFeature {
  AccessibleItems = 'AccessibleItems',
  Agencies = 'Agencies',
  AgencyLocations = 'AgencyLocations',
  Airports = 'Airports',
  Attachments = 'Attachments',
  BaseControlZones = 'BaseControlZones',
  BaseMedicalControlContacts = 'BaseMedicalControlContacts',
  Bases = 'Bases',
  Capabilities = 'Capabilities',
  CommunicationCenters = 'CommunicationCenters',
  CommunicationCenterTransportOfferOptions = 'CommunicationCenterTransportOfferOptions',
  Companies = 'Companies',
  CompleteFlightInstances = 'CompleteFlightInstances',
  ControlZones = 'ControlZones',
  Departments = 'Departments',
  EntityCapabilities = 'EntityCapabilities',
  ExternalReferences = 'ExternalReferences',
  Fbos = 'Fbos',
  FuelTanks = 'FuelTanks',
  Locations = 'Locations',
  MaintenanceFacilities = 'MaintenanceFacilities',
  MedicalFacilities = 'MedicalFacilities',
  MedicalFacilityContacts = 'MedicalFacilityContacts',
  MedicalFacilityPhysicians = 'MedicalFacilityPhysicians',
  MedicalFacilityUnits = 'MedicalFacilityUnits',
  OutOfServiceQARReasons = 'OutOfServiceQARReasons',
  People = 'People',
  Physicians = 'Physicians',
  ProgramBases = 'ProgramBases',
  Programs = 'Programs',
  RegionBases = 'RegionBases',
  RegionGroups = 'RegionGroups',
  Regions = 'Regions',
  ReleaseNotes = 'ReleaseNotes',
  SpecialtyTeamMembers = 'SpecialtyTeamMembers',
  SpecialtyTeams = 'SpecialtyTeams',
  States = 'States',
  SupportRequests = 'SupportRequests',
  Timezones = 'Timezones',
  TransferCenters = 'TransferCenters',
  TrmUsers = 'TrmUsers',
  VehicleConfigurationClasses = 'VehicleConfigurationClasses',
  VehicleControlZones = 'VehicleControlZones',
  VehicleMaintenances = 'VehicleMaintenances',
  VehicleMakes = 'VehicleMakes',
  VehicleModels = 'VehicleModels',
  Vehicles = 'Vehicles',
  VehicleStateInspections = 'VehicleStateInspections',
}

export type AccessibleItemsFeatureCommand =
  | OrgCommand.AddAccessibleItem
  | OrgCommand.DeleteAccessibleItem
  | OrgCommand.UpdateAccessibleItem;
export type AgenciesFeatureCommand =
  | OrgCommand.AddAgency
  | OrgCommand.DeleteAgency
  | OrgCommand.UpdateAgency;
export type AgencyLocationsFeatureCommand =
  | OrgCommand.AddAgencyLocation
  | OrgCommand.DeleteAgencyLocation
  | OrgCommand.LookupAgencyLocationByPhoneNumber
  | OrgCommand.UpdateAgencyLocation;
export type AirportsFeatureCommand =
  | OrgCommand.AddAirport
  | OrgCommand.DeleteAirport
  | OrgCommand.UpdateAirport;
export type AttachmentsFeatureCommand =
  | OrgCommand.DeleteAttachment
  | OrgCommand.GenerateAttachmentUrl;
export type BaseControlZonesFeatureCommand =
  | OrgCommand.AddBaseControlZone
  | OrgCommand.DeleteBaseControlZone
  | OrgCommand.UpdateBaseControlZone;
export type BaseMedicalControlContactsFeatureCommand =
  | OrgCommand.AddBaseMedicalControlContact
  | OrgCommand.DeleteBaseMedicalControlContact
  | OrgCommand.UpdateBaseMedicalControlContact;
export type BasesFeatureCommand =
  | OrgCommand.AddBase
  | OrgCommand.AddBaseAdditionalCompany
  | OrgCommand.DeleteBase
  | OrgCommand.RemoveBaseAdditionalCompany
  | OrgCommand.UpdateBase
  | OrgCommand.UpdateBaseCustomIdentifiers;
export type CapabilitiesFeatureCommand =
  | OrgCommand.AddCapability
  | OrgCommand.DeleteCapability
  | OrgCommand.UpdateCapability;
export type CommunicationCentersFeatureCommand =
  | OrgCommand.AddCommunicationCenter
  | OrgCommand.DeleteCommunicationCenter
  | OrgCommand.UpdateCommunicationCenter;
export type CommunicationCenterTransportOfferOptionsFeatureCommand =
  | OrgCommand.AddCommunicationCenterTransportOfferOption
  | OrgCommand.DeleteCommunicationCenterTransportOfferOption
  | OrgCommand.UpdateCommunicationCenterTransportOfferOption;
export type CompaniesFeatureCommand =
  | OrgCommand.AddCompany
  | OrgCommand.DeleteCompany
  | OrgCommand.UpdateCompany;
export type CompleteFlightInstancesFeatureCommand =
  | OrgCommand.AddCompleteFlightInstance
  | OrgCommand.DeleteCompleteFlightInstance
  | OrgCommand.UpdateCompleteFlightInstance;
export type ControlZonesFeatureCommand =
  | OrgCommand.AddControlZone
  | OrgCommand.DeleteControlZone
  | OrgCommand.UpdateControlZone;
export type DepartmentsFeatureCommand =
  | OrgCommand.AddDepartment
  | OrgCommand.DeleteDepartment
  | OrgCommand.UpdateDepartment;
export type EntityCapabilitiesFeatureCommand =
  | OrgCommand.AddEntityCapability
  | OrgCommand.DeleteEntityCapability;
export type ExternalReferencesFeatureCommand =
  | OrgCommand.AddExternalReference
  | OrgCommand.DeleteExternalReference
  | OrgCommand.UndeleteExternalReference
  | OrgCommand.UpdateExternalReference;
export type FbosFeatureCommand = OrgCommand.AddFbo | OrgCommand.DeleteFbo | OrgCommand.UpdateFbo;
export type FuelTanksFeatureCommand =
  | OrgCommand.AddFuelTank
  | OrgCommand.DeleteFuelTank
  | OrgCommand.UpdateFuelTank;
export type LocationsFeatureCommand =
  | OrgCommand.AddLocation
  | OrgCommand.DeleteLocation
  | OrgCommand.RefreshLocationsFromGMRWorkday
  | OrgCommand.UpdateLocation;
export type MaintenanceFacilitiesFeatureCommand =
  | OrgCommand.AddMaintenanceFacility
  | OrgCommand.DeleteMaintenanceFacility
  | OrgCommand.UpdateMaintenanceFacility;
export type MedicalFacilitiesFeatureCommand =
  | OrgCommand.AddMedicalFacility
  | OrgCommand.ApproveMedicalFacility
  | OrgCommand.ArchiveMedicalFacility
  | OrgCommand.ClearPendingArchiveMedicalFacility
  | OrgCommand.DeleteMedicalFacility
  | OrgCommand.MergeMedicalFacilities
  | OrgCommand.SubmitMedicalFacilityForApproval
  | OrgCommand.UnmarkMedicalFacilityAsDuplicate
  | OrgCommand.UpdateMedicalFacility
  | OrgCommand.UpdateMedicalFacilityCustomIdentifiers;
export type MedicalFacilityContactsFeatureCommand =
  | OrgCommand.AddMedicalFacilityContact
  | OrgCommand.DeleteMedicalFacilityContact
  | OrgCommand.UpdateMedicalFacilityContact;
export type MedicalFacilityPhysiciansFeatureCommand =
  | OrgCommand.AddMedicalFacilityPhysician
  | OrgCommand.DeleteMedicalFacilityPhysician
  | OrgCommand.UpdateMedicalFacilityPhysician;
export type MedicalFacilityUnitsFeatureCommand =
  | OrgCommand.AddMedicalFacilityUnit
  | OrgCommand.DeleteMedicalFacilityUnit
  | OrgCommand.UpdateMedicalFacilityUnit;
export type OutOfServiceQARReasonsFeatureCommand =
  | OrgCommand.AddOutOfServiceQARReason
  | OrgCommand.DeleteOutOfServiceQARReason
  | OrgCommand.UpdateOutOfServiceQARReason;
export type PeopleFeatureCommand =
  | OrgCommand.AddOutOfComplianceCrewMember
  | OrgCommand.AddPerson
  | OrgCommand.AddPersonAdditionalCompany
  | OrgCommand.AuthorizeClientSyncAccess
  | OrgCommand.DeletePerson
  | OrgCommand.GrantClientSyncAccess
  | OrgCommand.RefreshPeopleFromGMRWorkdayV2
  | OrgCommand.RemoveCrewMemberFromOutOfCompliance
  | OrgCommand.RemovePersonAdditionalCompany
  | OrgCommand.ResetPassword
  | OrgCommand.SetRoleScope
  | OrgCommand.UpdateOutOfComplianceCrewMember
  | OrgCommand.UpdatePerson
  | OrgCommand.UpdateTcsRealtimeTrackingTab;
export type PhysiciansFeatureCommand =
  | OrgCommand.AddPhysician
  | OrgCommand.DeletePhysician
  | OrgCommand.UpdatePhysician;
export type ProgramBasesFeatureCommand =
  | OrgCommand.AddProgramBase
  | OrgCommand.DeleteProgramBase
  | OrgCommand.UpdateProgramBase;
export type ProgramsFeatureCommand =
  | OrgCommand.AddProgram
  | OrgCommand.DeleteProgram
  | OrgCommand.UpdateProgram;
export type RegionBasesFeatureCommand =
  | OrgCommand.AddRegionBase
  | OrgCommand.DeleteRegionBase
  | OrgCommand.UpdateRegionBase;
export type RegionGroupsFeatureCommand =
  | OrgCommand.AddRegionGroup
  | OrgCommand.DeleteRegionGroup
  | OrgCommand.UpdateRegionGroup;
export type RegionsFeatureCommand =
  | OrgCommand.AddRegion
  | OrgCommand.AddTransferCenterRegion
  | OrgCommand.DeleteRegion
  | OrgCommand.UpdateRegion;
export type ReleaseNotesFeatureCommand =
  | OrgCommand.AddReleaseNote
  | OrgCommand.DeleteReleaseNote
  | OrgCommand.UpdateReleaseNote;
export type SpecialtyTeamMembersFeatureCommand =
  | OrgCommand.AddExistingSpecialtyTeamMember
  | OrgCommand.AddSpecialtyTeamMember
  | OrgCommand.DeleteSpecialtyTeamMember
  | OrgCommand.UpdateSpecialtyTeamMember;
export type SpecialtyTeamsFeatureCommand =
  | OrgCommand.AddSpecialtyTeam
  | OrgCommand.DeleteSpecialtyTeam
  | OrgCommand.UpdateSpecialtyTeam;
export type StatesFeatureCommand =
  | OrgCommand.AddState
  | OrgCommand.DeleteState
  | OrgCommand.UpdateState;
export type SupportRequestsFeatureCommand =
  | OrgCommand.AddSupportRequest
  | OrgCommand.DeleteSupportRequest
  | OrgCommand.SetSupportRequestState
  | OrgCommand.SubmitSupportRequest
  | OrgCommand.UpdateSupportRequest
  | OrgCommand.UpdateSupportRequestEmailSent;
export type TimezonesFeatureCommand =
  | OrgCommand.AddTimezone
  | OrgCommand.DeleteTimezone
  | OrgCommand.UpdateTimezone;
export type TransferCentersFeatureCommand =
  | OrgCommand.AddTransferCenter
  | OrgCommand.DeleteTransferCenter
  | OrgCommand.UpdateTransferCenter;
export type TrmUsersFeatureCommand =
  | OrgCommand.AddPreApprovedTrmUser
  | OrgCommand.ApproveTrmUser
  | OrgCommand.DeactivateTrmUser
  | OrgCommand.DeleteTrmUser
  | OrgCommand.DenyTrmUser
  | OrgCommand.RegisterTrmUser
  | OrgCommand.UpdateTrmUser;
export type VehicleConfigurationClassesFeatureCommand =
  | OrgCommand.AddVehicleConfigurationClass
  | OrgCommand.DeleteVehicleConfigurationClass
  | OrgCommand.UpdateVehicleConfigurationClass;
export type VehicleControlZonesFeatureCommand =
  | OrgCommand.AddVehicleControlZone
  | OrgCommand.DeleteVehicleControlZone
  | OrgCommand.UpdateVehicleControlZone;
export type VehicleMaintenancesFeatureCommand =
  | OrgCommand.AddVehicleMaintenance
  | OrgCommand.DeleteVehicleMaintenance
  | OrgCommand.UpdateVehicleMaintenance
  | OrgCommand.UpsertVehicleMaintenanceParameters;
export type VehicleMakesFeatureCommand =
  | OrgCommand.AddVehicleMake
  | OrgCommand.DeleteVehicleMake
  | OrgCommand.UpdateVehicleMake;
export type VehicleModelsFeatureCommand =
  | OrgCommand.AddVehicleModel
  | OrgCommand.DeleteVehicleModel
  | OrgCommand.UpdateVehicleModel;
export type VehiclesFeatureCommand =
  | OrgCommand.AddVehicle
  | OrgCommand.ChangeVehicleFlightLogProcess
  | OrgCommand.DeleteVehicle
  | OrgCommand.EnsureThirdPartyVehicleAndUnit
  | OrgCommand.HideVehicle
  | OrgCommand.SetVehicleControlZoneId
  | OrgCommand.UndeleteVehicle
  | OrgCommand.UnhideVehicle
  | OrgCommand.UpdateVehicle;
export type VehicleStateInspectionsFeatureCommand =
  | OrgCommand.AddVehicleStateInspection
  | OrgCommand.DeleteVehicleStateInspection
  | OrgCommand.UpdateVehicleStateInspection;

export const OrgFeatures: { [key in OrgFeature]: OrgCommand[] } = {
  AccessibleItems: [
    OrgCommand.AddAccessibleItem,
    OrgCommand.DeleteAccessibleItem,
    OrgCommand.UpdateAccessibleItem,
  ],
  Agencies: [OrgCommand.AddAgency, OrgCommand.DeleteAgency, OrgCommand.UpdateAgency],
  AgencyLocations: [
    OrgCommand.AddAgencyLocation,
    OrgCommand.DeleteAgencyLocation,
    OrgCommand.LookupAgencyLocationByPhoneNumber,
    OrgCommand.UpdateAgencyLocation,
  ],
  Airports: [OrgCommand.AddAirport, OrgCommand.DeleteAirport, OrgCommand.UpdateAirport],
  Attachments: [OrgCommand.DeleteAttachment, OrgCommand.GenerateAttachmentUrl],
  BaseControlZones: [
    OrgCommand.AddBaseControlZone,
    OrgCommand.DeleteBaseControlZone,
    OrgCommand.UpdateBaseControlZone,
  ],
  BaseMedicalControlContacts: [
    OrgCommand.AddBaseMedicalControlContact,
    OrgCommand.DeleteBaseMedicalControlContact,
    OrgCommand.UpdateBaseMedicalControlContact,
  ],
  Bases: [
    OrgCommand.AddBase,
    OrgCommand.AddBaseAdditionalCompany,
    OrgCommand.DeleteBase,
    OrgCommand.RemoveBaseAdditionalCompany,
    OrgCommand.UpdateBase,
    OrgCommand.UpdateBaseCustomIdentifiers,
  ],
  Capabilities: [
    OrgCommand.AddCapability,
    OrgCommand.DeleteCapability,
    OrgCommand.UpdateCapability,
  ],
  CommunicationCenters: [
    OrgCommand.AddCommunicationCenter,
    OrgCommand.DeleteCommunicationCenter,
    OrgCommand.UpdateCommunicationCenter,
  ],
  CommunicationCenterTransportOfferOptions: [
    OrgCommand.AddCommunicationCenterTransportOfferOption,
    OrgCommand.DeleteCommunicationCenterTransportOfferOption,
    OrgCommand.UpdateCommunicationCenterTransportOfferOption,
  ],
  Companies: [OrgCommand.AddCompany, OrgCommand.DeleteCompany, OrgCommand.UpdateCompany],
  CompleteFlightInstances: [
    OrgCommand.AddCompleteFlightInstance,
    OrgCommand.DeleteCompleteFlightInstance,
    OrgCommand.UpdateCompleteFlightInstance,
  ],
  ControlZones: [
    OrgCommand.AddControlZone,
    OrgCommand.DeleteControlZone,
    OrgCommand.UpdateControlZone,
  ],
  Departments: [OrgCommand.AddDepartment, OrgCommand.DeleteDepartment, OrgCommand.UpdateDepartment],
  EntityCapabilities: [OrgCommand.AddEntityCapability, OrgCommand.DeleteEntityCapability],
  ExternalReferences: [
    OrgCommand.AddExternalReference,
    OrgCommand.DeleteExternalReference,
    OrgCommand.UndeleteExternalReference,
    OrgCommand.UpdateExternalReference,
  ],
  Fbos: [OrgCommand.AddFbo, OrgCommand.DeleteFbo, OrgCommand.UpdateFbo],
  FuelTanks: [OrgCommand.AddFuelTank, OrgCommand.DeleteFuelTank, OrgCommand.UpdateFuelTank],
  Locations: [
    OrgCommand.AddLocation,
    OrgCommand.DeleteLocation,
    OrgCommand.RefreshLocationsFromGMRWorkday,
    OrgCommand.UpdateLocation,
  ],
  MaintenanceFacilities: [
    OrgCommand.AddMaintenanceFacility,
    OrgCommand.DeleteMaintenanceFacility,
    OrgCommand.UpdateMaintenanceFacility,
  ],
  MedicalFacilities: [
    OrgCommand.AddMedicalFacility,
    OrgCommand.ApproveMedicalFacility,
    OrgCommand.ArchiveMedicalFacility,
    OrgCommand.ClearPendingArchiveMedicalFacility,
    OrgCommand.DeleteMedicalFacility,
    OrgCommand.MergeMedicalFacilities,
    OrgCommand.SubmitMedicalFacilityForApproval,
    OrgCommand.UnmarkMedicalFacilityAsDuplicate,
    OrgCommand.UpdateMedicalFacility,
    OrgCommand.UpdateMedicalFacilityCustomIdentifiers,
  ],
  MedicalFacilityContacts: [
    OrgCommand.AddMedicalFacilityContact,
    OrgCommand.DeleteMedicalFacilityContact,
    OrgCommand.UpdateMedicalFacilityContact,
  ],
  MedicalFacilityPhysicians: [
    OrgCommand.AddMedicalFacilityPhysician,
    OrgCommand.DeleteMedicalFacilityPhysician,
    OrgCommand.UpdateMedicalFacilityPhysician,
  ],
  MedicalFacilityUnits: [
    OrgCommand.AddMedicalFacilityUnit,
    OrgCommand.DeleteMedicalFacilityUnit,
    OrgCommand.UpdateMedicalFacilityUnit,
  ],
  OutOfServiceQARReasons: [
    OrgCommand.AddOutOfServiceQARReason,
    OrgCommand.DeleteOutOfServiceQARReason,
    OrgCommand.UpdateOutOfServiceQARReason,
  ],
  People: [
    OrgCommand.AddOutOfComplianceCrewMember,
    OrgCommand.AddPerson,
    OrgCommand.AddPersonAdditionalCompany,
    OrgCommand.AuthorizeClientSyncAccess,
    OrgCommand.DeletePerson,
    OrgCommand.GrantClientSyncAccess,
    OrgCommand.RefreshPeopleFromGMRWorkdayV2,
    OrgCommand.RemoveCrewMemberFromOutOfCompliance,
    OrgCommand.RemovePersonAdditionalCompany,
    OrgCommand.ResetPassword,
    OrgCommand.SetRoleScope,
    OrgCommand.UpdateOutOfComplianceCrewMember,
    OrgCommand.UpdatePerson,
    OrgCommand.UpdateTcsRealtimeTrackingTab,
  ],
  Physicians: [OrgCommand.AddPhysician, OrgCommand.DeletePhysician, OrgCommand.UpdatePhysician],
  ProgramBases: [
    OrgCommand.AddProgramBase,
    OrgCommand.DeleteProgramBase,
    OrgCommand.UpdateProgramBase,
  ],
  Programs: [OrgCommand.AddProgram, OrgCommand.DeleteProgram, OrgCommand.UpdateProgram],
  RegionBases: [OrgCommand.AddRegionBase, OrgCommand.DeleteRegionBase, OrgCommand.UpdateRegionBase],
  RegionGroups: [
    OrgCommand.AddRegionGroup,
    OrgCommand.DeleteRegionGroup,
    OrgCommand.UpdateRegionGroup,
  ],
  Regions: [
    OrgCommand.AddRegion,
    OrgCommand.AddTransferCenterRegion,
    OrgCommand.DeleteRegion,
    OrgCommand.UpdateRegion,
  ],
  ReleaseNotes: [
    OrgCommand.AddReleaseNote,
    OrgCommand.DeleteReleaseNote,
    OrgCommand.UpdateReleaseNote,
  ],
  SpecialtyTeamMembers: [
    OrgCommand.AddExistingSpecialtyTeamMember,
    OrgCommand.AddSpecialtyTeamMember,
    OrgCommand.DeleteSpecialtyTeamMember,
    OrgCommand.UpdateSpecialtyTeamMember,
  ],
  SpecialtyTeams: [
    OrgCommand.AddSpecialtyTeam,
    OrgCommand.DeleteSpecialtyTeam,
    OrgCommand.UpdateSpecialtyTeam,
  ],
  States: [OrgCommand.AddState, OrgCommand.DeleteState, OrgCommand.UpdateState],
  SupportRequests: [
    OrgCommand.AddSupportRequest,
    OrgCommand.DeleteSupportRequest,
    OrgCommand.SetSupportRequestState,
    OrgCommand.SubmitSupportRequest,
    OrgCommand.UpdateSupportRequest,
    OrgCommand.UpdateSupportRequestEmailSent,
  ],
  Timezones: [OrgCommand.AddTimezone, OrgCommand.DeleteTimezone, OrgCommand.UpdateTimezone],
  TransferCenters: [
    OrgCommand.AddTransferCenter,
    OrgCommand.DeleteTransferCenter,
    OrgCommand.UpdateTransferCenter,
  ],
  TrmUsers: [
    OrgCommand.AddPreApprovedTrmUser,
    OrgCommand.ApproveTrmUser,
    OrgCommand.DeactivateTrmUser,
    OrgCommand.DeleteTrmUser,
    OrgCommand.DenyTrmUser,
    OrgCommand.RegisterTrmUser,
    OrgCommand.UpdateTrmUser,
  ],
  VehicleConfigurationClasses: [
    OrgCommand.AddVehicleConfigurationClass,
    OrgCommand.DeleteVehicleConfigurationClass,
    OrgCommand.UpdateVehicleConfigurationClass,
  ],
  VehicleControlZones: [
    OrgCommand.AddVehicleControlZone,
    OrgCommand.DeleteVehicleControlZone,
    OrgCommand.UpdateVehicleControlZone,
  ],
  VehicleMaintenances: [
    OrgCommand.AddVehicleMaintenance,
    OrgCommand.DeleteVehicleMaintenance,
    OrgCommand.UpdateVehicleMaintenance,
    OrgCommand.UpsertVehicleMaintenanceParameters,
  ],
  VehicleMakes: [
    OrgCommand.AddVehicleMake,
    OrgCommand.DeleteVehicleMake,
    OrgCommand.UpdateVehicleMake,
  ],
  VehicleModels: [
    OrgCommand.AddVehicleModel,
    OrgCommand.DeleteVehicleModel,
    OrgCommand.UpdateVehicleModel,
  ],
  Vehicles: [
    OrgCommand.AddVehicle,
    OrgCommand.ChangeVehicleFlightLogProcess,
    OrgCommand.DeleteVehicle,
    OrgCommand.EnsureThirdPartyVehicleAndUnit,
    OrgCommand.HideVehicle,
    OrgCommand.SetVehicleControlZoneId,
    OrgCommand.UndeleteVehicle,
    OrgCommand.UnhideVehicle,
    OrgCommand.UpdateVehicle,
  ],
  VehicleStateInspections: [
    OrgCommand.AddVehicleStateInspection,
    OrgCommand.DeleteVehicleStateInspection,
    OrgCommand.UpdateVehicleStateInspection,
  ],
};

export class OrganizationMutations {
  constructor(private _executor: GraphqlMutationExecutorService) {}

  // AccessibleItems
  public addAccessibleItem<T = any>(
    command: AddAccessibleItem,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddAccessibleItem',
      AddAccessibleItemMutation,
      AddAccessibleItemMutationVariables,
      T
    >({
      name: 'AddAccessibleItem',
      mutation: gql`
        mutation AddAccessibleItemMutation($command: AddAccessibleItem!) {
          addAccessibleItem(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteAccessibleItem<T = any>(
    command: DeleteAccessibleItem,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteAccessibleItem',
      DeleteAccessibleItemMutation,
      DeleteAccessibleItemMutationVariables,
      T
    >({
      name: 'DeleteAccessibleItem',
      mutation: gql`
        mutation DeleteAccessibleItemMutation($command: DeleteAccessibleItem!) {
          deleteAccessibleItem(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateAccessibleItem<T = any>(
    command: UpdateAccessibleItem,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateAccessibleItem',
      UpdateAccessibleItemMutation,
      UpdateAccessibleItemMutationVariables,
      T
    >({
      name: 'UpdateAccessibleItem',
      mutation: gql`
        mutation UpdateAccessibleItemMutation($command: UpdateAccessibleItem!) {
          updateAccessibleItem(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Agencies
  public addAgency<T = any>(
    command: AddAgency,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddAgency', AddAgencyMutation, AddAgencyMutationVariables, T>({
      name: 'AddAgency',
      mutation: gql`
        mutation AddAgencyMutation($command: AddAgency!) {
          addAgency(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteAgency<T = any>(
    command: DeleteAgency,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteAgency',
      DeleteAgencyMutation,
      DeleteAgencyMutationVariables,
      T
    >({
      name: 'DeleteAgency',
      mutation: gql`
        mutation DeleteAgencyMutation($command: DeleteAgency!) {
          deleteAgency(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateAgency<T = any>(
    command: UpdateAgency,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateAgency',
      UpdateAgencyMutation,
      UpdateAgencyMutationVariables,
      T
    >({
      name: 'UpdateAgency',
      mutation: gql`
        mutation UpdateAgencyMutation($command: UpdateAgency!) {
          updateAgency(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // AgencyLocations
  public addAgencyLocation<T = any>(
    command: AddAgencyLocation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddAgencyLocation',
      AddAgencyLocationMutation,
      AddAgencyLocationMutationVariables,
      T
    >({
      name: 'AddAgencyLocation',
      mutation: gql`
        mutation AddAgencyLocationMutation($command: AddAgencyLocation!) {
          addAgencyLocation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteAgencyLocation<T = any>(
    command: DeleteAgencyLocation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteAgencyLocation',
      DeleteAgencyLocationMutation,
      DeleteAgencyLocationMutationVariables,
      T
    >({
      name: 'DeleteAgencyLocation',
      mutation: gql`
        mutation DeleteAgencyLocationMutation($command: DeleteAgencyLocation!) {
          deleteAgencyLocation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public lookupAgencyLocationByPhoneNumber<T = any>(
    command: LookupAgencyLocationByPhoneNumber,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'LookupAgencyLocationByPhoneNumber',
      LookupAgencyLocationByPhoneNumberMutation,
      LookupAgencyLocationByPhoneNumberMutationVariables,
      T
    >({
      name: 'LookupAgencyLocationByPhoneNumber',
      mutation: gql`
        mutation LookupAgencyLocationByPhoneNumberMutation(
          $command: LookupAgencyLocationByPhoneNumber!
        ) {
          lookupAgencyLocationByPhoneNumber(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateAgencyLocation<T = any>(
    command: UpdateAgencyLocation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateAgencyLocation',
      UpdateAgencyLocationMutation,
      UpdateAgencyLocationMutationVariables,
      T
    >({
      name: 'UpdateAgencyLocation',
      mutation: gql`
        mutation UpdateAgencyLocationMutation($command: UpdateAgencyLocation!) {
          updateAgencyLocation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Airports
  public addAirport<T = any>(
    command: AddAirport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddAirport', AddAirportMutation, AddAirportMutationVariables, T>(
      {
        name: 'AddAirport',
        mutation: gql`
          mutation AddAirportMutation($command: AddAirport!) {
            addAirport(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public deleteAirport<T = any>(
    command: DeleteAirport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteAirport',
      DeleteAirportMutation,
      DeleteAirportMutationVariables,
      T
    >({
      name: 'DeleteAirport',
      mutation: gql`
        mutation DeleteAirportMutation($command: DeleteAirport!) {
          deleteAirport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateAirport<T = any>(
    command: UpdateAirport,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateAirport',
      UpdateAirportMutation,
      UpdateAirportMutationVariables,
      T
    >({
      name: 'UpdateAirport',
      mutation: gql`
        mutation UpdateAirportMutation($command: UpdateAirport!) {
          updateAirport(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Attachments
  public deleteAttachment<T = any>(
    command: DeleteAttachment,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteAttachment',
      DeleteAttachmentMutation,
      DeleteAttachmentMutationVariables,
      T
    >({
      name: 'DeleteAttachment',
      mutation: gql`
        mutation DeleteAttachmentMutation($command: DeleteAttachment!) {
          deleteAttachment(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public generateAttachmentUrl<T = any>(
    command: GenerateAttachmentUrl,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'GenerateAttachmentUrl',
      GenerateAttachmentUrlMutation,
      GenerateAttachmentUrlMutationVariables,
      T
    >({
      name: 'GenerateAttachmentUrl',
      mutation: gql`
        mutation GenerateAttachmentUrlMutation($command: GenerateAttachmentUrl!) {
          generateAttachmentUrl(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // BaseControlZones
  public addBaseControlZone<T = any>(
    command: AddBaseControlZone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddBaseControlZone',
      AddBaseControlZoneMutation,
      AddBaseControlZoneMutationVariables,
      T
    >({
      name: 'AddBaseControlZone',
      mutation: gql`
        mutation AddBaseControlZoneMutation($command: AddBaseControlZone!) {
          addBaseControlZone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteBaseControlZone<T = any>(
    command: DeleteBaseControlZone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteBaseControlZone',
      DeleteBaseControlZoneMutation,
      DeleteBaseControlZoneMutationVariables,
      T
    >({
      name: 'DeleteBaseControlZone',
      mutation: gql`
        mutation DeleteBaseControlZoneMutation($command: DeleteBaseControlZone!) {
          deleteBaseControlZone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateBaseControlZone<T = any>(
    command: UpdateBaseControlZone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateBaseControlZone',
      UpdateBaseControlZoneMutation,
      UpdateBaseControlZoneMutationVariables,
      T
    >({
      name: 'UpdateBaseControlZone',
      mutation: gql`
        mutation UpdateBaseControlZoneMutation($command: UpdateBaseControlZone!) {
          updateBaseControlZone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // BaseMedicalControlContacts
  public addBaseMedicalControlContact<T = any>(
    command: AddBaseMedicalControlContact,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddBaseMedicalControlContact',
      AddBaseMedicalControlContactMutation,
      AddBaseMedicalControlContactMutationVariables,
      T
    >({
      name: 'AddBaseMedicalControlContact',
      mutation: gql`
        mutation AddBaseMedicalControlContactMutation($command: AddBaseMedicalControlContact!) {
          addBaseMedicalControlContact(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteBaseMedicalControlContact<T = any>(
    command: DeleteBaseMedicalControlContact,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteBaseMedicalControlContact',
      DeleteBaseMedicalControlContactMutation,
      DeleteBaseMedicalControlContactMutationVariables,
      T
    >({
      name: 'DeleteBaseMedicalControlContact',
      mutation: gql`
        mutation DeleteBaseMedicalControlContactMutation(
          $command: DeleteBaseMedicalControlContact!
        ) {
          deleteBaseMedicalControlContact(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateBaseMedicalControlContact<T = any>(
    command: UpdateBaseMedicalControlContact,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateBaseMedicalControlContact',
      UpdateBaseMedicalControlContactMutation,
      UpdateBaseMedicalControlContactMutationVariables,
      T
    >({
      name: 'UpdateBaseMedicalControlContact',
      mutation: gql`
        mutation UpdateBaseMedicalControlContactMutation(
          $command: UpdateBaseMedicalControlContact!
        ) {
          updateBaseMedicalControlContact(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // BaseMedicalControlContactStates
  // Bases
  public addBase<T = any>(
    command: AddBase,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddBase', AddBaseMutation, AddBaseMutationVariables, T>({
      name: 'AddBase',
      mutation: gql`
        mutation AddBaseMutation($command: AddBase!) {
          addBase(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addBaseAdditionalCompany<T = any>(
    command: AddBaseAdditionalCompany,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddBaseAdditionalCompany',
      AddBaseAdditionalCompanyMutation,
      AddBaseAdditionalCompanyMutationVariables,
      T
    >({
      name: 'AddBaseAdditionalCompany',
      mutation: gql`
        mutation AddBaseAdditionalCompanyMutation($command: AddBaseAdditionalCompany!) {
          addBaseAdditionalCompany(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteBase<T = any>(
    command: DeleteBase,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'DeleteBase', DeleteBaseMutation, DeleteBaseMutationVariables, T>(
      {
        name: 'DeleteBase',
        mutation: gql`
          mutation DeleteBaseMutation($command: DeleteBase!) {
            deleteBase(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public removeBaseAdditionalCompany<T = any>(
    command: RemoveBaseAdditionalCompany,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RemoveBaseAdditionalCompany',
      RemoveBaseAdditionalCompanyMutation,
      RemoveBaseAdditionalCompanyMutationVariables,
      T
    >({
      name: 'RemoveBaseAdditionalCompany',
      mutation: gql`
        mutation RemoveBaseAdditionalCompanyMutation($command: RemoveBaseAdditionalCompany!) {
          removeBaseAdditionalCompany(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateBase<T = any>(
    command: UpdateBase,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'UpdateBase', UpdateBaseMutation, UpdateBaseMutationVariables, T>(
      {
        name: 'UpdateBase',
        mutation: gql`
          mutation UpdateBaseMutation($command: UpdateBase!) {
            updateBase(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public updateBaseCustomIdentifiers<T = any>(
    command: UpdateBaseCustomIdentifiers,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateBaseCustomIdentifiers',
      UpdateBaseCustomIdentifiersMutation,
      UpdateBaseCustomIdentifiersMutationVariables,
      T
    >({
      name: 'UpdateBaseCustomIdentifiers',
      mutation: gql`
        mutation UpdateBaseCustomIdentifiersMutation($command: UpdateBaseCustomIdentifiers!) {
          updateBaseCustomIdentifiers(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Capabilities
  public addCapability<T = any>(
    command: AddCapability,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCapability',
      AddCapabilityMutation,
      AddCapabilityMutationVariables,
      T
    >({
      name: 'AddCapability',
      mutation: gql`
        mutation AddCapabilityMutation($command: AddCapability!) {
          addCapability(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCapability<T = any>(
    command: DeleteCapability,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCapability',
      DeleteCapabilityMutation,
      DeleteCapabilityMutationVariables,
      T
    >({
      name: 'DeleteCapability',
      mutation: gql`
        mutation DeleteCapabilityMutation($command: DeleteCapability!) {
          deleteCapability(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCapability<T = any>(
    command: UpdateCapability,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCapability',
      UpdateCapabilityMutation,
      UpdateCapabilityMutationVariables,
      T
    >({
      name: 'UpdateCapability',
      mutation: gql`
        mutation UpdateCapabilityMutation($command: UpdateCapability!) {
          updateCapability(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // CommunicationCenters
  public addCommunicationCenter<T = any>(
    command: AddCommunicationCenter,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCommunicationCenter',
      AddCommunicationCenterMutation,
      AddCommunicationCenterMutationVariables,
      T
    >({
      name: 'AddCommunicationCenter',
      mutation: gql`
        mutation AddCommunicationCenterMutation($command: AddCommunicationCenter!) {
          addCommunicationCenter(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCommunicationCenter<T = any>(
    command: DeleteCommunicationCenter,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCommunicationCenter',
      DeleteCommunicationCenterMutation,
      DeleteCommunicationCenterMutationVariables,
      T
    >({
      name: 'DeleteCommunicationCenter',
      mutation: gql`
        mutation DeleteCommunicationCenterMutation($command: DeleteCommunicationCenter!) {
          deleteCommunicationCenter(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCommunicationCenter<T = any>(
    command: UpdateCommunicationCenter,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCommunicationCenter',
      UpdateCommunicationCenterMutation,
      UpdateCommunicationCenterMutationVariables,
      T
    >({
      name: 'UpdateCommunicationCenter',
      mutation: gql`
        mutation UpdateCommunicationCenterMutation($command: UpdateCommunicationCenter!) {
          updateCommunicationCenter(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // CommunicationCenterTransportOfferOptions
  public addCommunicationCenterTransportOfferOption<T = any>(
    command: AddCommunicationCenterTransportOfferOption,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCommunicationCenterTransportOfferOption',
      AddCommunicationCenterTransportOfferOptionMutation,
      AddCommunicationCenterTransportOfferOptionMutationVariables,
      T
    >({
      name: 'AddCommunicationCenterTransportOfferOption',
      mutation: gql`
        mutation AddCommunicationCenterTransportOfferOptionMutation(
          $command: AddCommunicationCenterTransportOfferOption!
        ) {
          addCommunicationCenterTransportOfferOption(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCommunicationCenterTransportOfferOption<T = any>(
    command: DeleteCommunicationCenterTransportOfferOption,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCommunicationCenterTransportOfferOption',
      DeleteCommunicationCenterTransportOfferOptionMutation,
      DeleteCommunicationCenterTransportOfferOptionMutationVariables,
      T
    >({
      name: 'DeleteCommunicationCenterTransportOfferOption',
      mutation: gql`
        mutation DeleteCommunicationCenterTransportOfferOptionMutation(
          $command: DeleteCommunicationCenterTransportOfferOption!
        ) {
          deleteCommunicationCenterTransportOfferOption(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCommunicationCenterTransportOfferOption<T = any>(
    command: UpdateCommunicationCenterTransportOfferOption,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCommunicationCenterTransportOfferOption',
      UpdateCommunicationCenterTransportOfferOptionMutation,
      UpdateCommunicationCenterTransportOfferOptionMutationVariables,
      T
    >({
      name: 'UpdateCommunicationCenterTransportOfferOption',
      mutation: gql`
        mutation UpdateCommunicationCenterTransportOfferOptionMutation(
          $command: UpdateCommunicationCenterTransportOfferOption!
        ) {
          updateCommunicationCenterTransportOfferOption(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Companies
  public addCompany<T = any>(
    command: AddCompany,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddCompany', AddCompanyMutation, AddCompanyMutationVariables, T>(
      {
        name: 'AddCompany',
        mutation: gql`
          mutation AddCompanyMutation($command: AddCompany!) {
            addCompany(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public deleteCompany<T = any>(
    command: DeleteCompany,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCompany',
      DeleteCompanyMutation,
      DeleteCompanyMutationVariables,
      T
    >({
      name: 'DeleteCompany',
      mutation: gql`
        mutation DeleteCompanyMutation($command: DeleteCompany!) {
          deleteCompany(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCompany<T = any>(
    command: UpdateCompany,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCompany',
      UpdateCompanyMutation,
      UpdateCompanyMutationVariables,
      T
    >({
      name: 'UpdateCompany',
      mutation: gql`
        mutation UpdateCompanyMutation($command: UpdateCompany!) {
          updateCompany(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // CompleteFlightInstances
  public addCompleteFlightInstance<T = any>(
    command: AddCompleteFlightInstance,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddCompleteFlightInstance',
      AddCompleteFlightInstanceMutation,
      AddCompleteFlightInstanceMutationVariables,
      T
    >({
      name: 'AddCompleteFlightInstance',
      mutation: gql`
        mutation AddCompleteFlightInstanceMutation($command: AddCompleteFlightInstance!) {
          addCompleteFlightInstance(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteCompleteFlightInstance<T = any>(
    command: DeleteCompleteFlightInstance,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteCompleteFlightInstance',
      DeleteCompleteFlightInstanceMutation,
      DeleteCompleteFlightInstanceMutationVariables,
      T
    >({
      name: 'DeleteCompleteFlightInstance',
      mutation: gql`
        mutation DeleteCompleteFlightInstanceMutation($command: DeleteCompleteFlightInstance!) {
          deleteCompleteFlightInstance(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateCompleteFlightInstance<T = any>(
    command: UpdateCompleteFlightInstance,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateCompleteFlightInstance',
      UpdateCompleteFlightInstanceMutation,
      UpdateCompleteFlightInstanceMutationVariables,
      T
    >({
      name: 'UpdateCompleteFlightInstance',
      mutation: gql`
        mutation UpdateCompleteFlightInstanceMutation($command: UpdateCompleteFlightInstance!) {
          updateCompleteFlightInstance(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ControlZones
  public addControlZone<T = any>(
    command: AddControlZone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddControlZone',
      AddControlZoneMutation,
      AddControlZoneMutationVariables,
      T
    >({
      name: 'AddControlZone',
      mutation: gql`
        mutation AddControlZoneMutation($command: AddControlZone!) {
          addControlZone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteControlZone<T = any>(
    command: DeleteControlZone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteControlZone',
      DeleteControlZoneMutation,
      DeleteControlZoneMutationVariables,
      T
    >({
      name: 'DeleteControlZone',
      mutation: gql`
        mutation DeleteControlZoneMutation($command: DeleteControlZone!) {
          deleteControlZone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateControlZone<T = any>(
    command: UpdateControlZone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateControlZone',
      UpdateControlZoneMutation,
      UpdateControlZoneMutationVariables,
      T
    >({
      name: 'UpdateControlZone',
      mutation: gql`
        mutation UpdateControlZoneMutation($command: UpdateControlZone!) {
          updateControlZone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Departments
  public addDepartment<T = any>(
    command: AddDepartment,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddDepartment',
      AddDepartmentMutation,
      AddDepartmentMutationVariables,
      T
    >({
      name: 'AddDepartment',
      mutation: gql`
        mutation AddDepartmentMutation($command: AddDepartment!) {
          addDepartment(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteDepartment<T = any>(
    command: DeleteDepartment,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteDepartment',
      DeleteDepartmentMutation,
      DeleteDepartmentMutationVariables,
      T
    >({
      name: 'DeleteDepartment',
      mutation: gql`
        mutation DeleteDepartmentMutation($command: DeleteDepartment!) {
          deleteDepartment(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateDepartment<T = any>(
    command: UpdateDepartment,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateDepartment',
      UpdateDepartmentMutation,
      UpdateDepartmentMutationVariables,
      T
    >({
      name: 'UpdateDepartment',
      mutation: gql`
        mutation UpdateDepartmentMutation($command: UpdateDepartment!) {
          updateDepartment(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // EntityCapabilities
  public addEntityCapability<T = any>(
    command: AddEntityCapability,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddEntityCapability',
      AddEntityCapabilityMutation,
      AddEntityCapabilityMutationVariables,
      T
    >({
      name: 'AddEntityCapability',
      mutation: gql`
        mutation AddEntityCapabilityMutation($command: AddEntityCapability!) {
          addEntityCapability(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteEntityCapability<T = any>(
    command: DeleteEntityCapability,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteEntityCapability',
      DeleteEntityCapabilityMutation,
      DeleteEntityCapabilityMutationVariables,
      T
    >({
      name: 'DeleteEntityCapability',
      mutation: gql`
        mutation DeleteEntityCapabilityMutation($command: DeleteEntityCapability!) {
          deleteEntityCapability(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ExternalReferences
  public addExternalReference<T = any>(
    command: AddExternalReference,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddExternalReference',
      AddExternalReferenceMutation,
      AddExternalReferenceMutationVariables,
      T
    >({
      name: 'AddExternalReference',
      mutation: gql`
        mutation AddExternalReferenceMutation($command: AddExternalReference!) {
          addExternalReference(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteExternalReference<T = any>(
    command: DeleteExternalReference,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteExternalReference',
      DeleteExternalReferenceMutation,
      DeleteExternalReferenceMutationVariables,
      T
    >({
      name: 'DeleteExternalReference',
      mutation: gql`
        mutation DeleteExternalReferenceMutation($command: DeleteExternalReference!) {
          deleteExternalReference(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public undeleteExternalReference<T = any>(
    command: UndeleteExternalReference,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UndeleteExternalReference',
      UndeleteExternalReferenceMutation,
      UndeleteExternalReferenceMutationVariables,
      T
    >({
      name: 'UndeleteExternalReference',
      mutation: gql`
        mutation UndeleteExternalReferenceMutation($command: UndeleteExternalReference!) {
          undeleteExternalReference(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateExternalReference<T = any>(
    command: UpdateExternalReference,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateExternalReference',
      UpdateExternalReferenceMutation,
      UpdateExternalReferenceMutationVariables,
      T
    >({
      name: 'UpdateExternalReference',
      mutation: gql`
        mutation UpdateExternalReferenceMutation($command: UpdateExternalReference!) {
          updateExternalReference(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Fbos
  public addFbo<T = any>(
    command: AddFbo,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddFbo', AddFboMutation, AddFboMutationVariables, T>({
      name: 'AddFbo',
      mutation: gql`
        mutation AddFboMutation($command: AddFbo!) {
          addFbo(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteFbo<T = any>(
    command: DeleteFbo,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'DeleteFbo', DeleteFboMutation, DeleteFboMutationVariables, T>({
      name: 'DeleteFbo',
      mutation: gql`
        mutation DeleteFboMutation($command: DeleteFbo!) {
          deleteFbo(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateFbo<T = any>(
    command: UpdateFbo,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'UpdateFbo', UpdateFboMutation, UpdateFboMutationVariables, T>({
      name: 'UpdateFbo',
      mutation: gql`
        mutation UpdateFboMutation($command: UpdateFbo!) {
          updateFbo(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // FuelTanks
  public addFuelTank<T = any>(
    command: AddFuelTank,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddFuelTank',
      AddFuelTankMutation,
      AddFuelTankMutationVariables,
      T
    >({
      name: 'AddFuelTank',
      mutation: gql`
        mutation AddFuelTankMutation($command: AddFuelTank!) {
          addFuelTank(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteFuelTank<T = any>(
    command: DeleteFuelTank,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteFuelTank',
      DeleteFuelTankMutation,
      DeleteFuelTankMutationVariables,
      T
    >({
      name: 'DeleteFuelTank',
      mutation: gql`
        mutation DeleteFuelTankMutation($command: DeleteFuelTank!) {
          deleteFuelTank(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateFuelTank<T = any>(
    command: UpdateFuelTank,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateFuelTank',
      UpdateFuelTankMutation,
      UpdateFuelTankMutationVariables,
      T
    >({
      name: 'UpdateFuelTank',
      mutation: gql`
        mutation UpdateFuelTankMutation($command: UpdateFuelTank!) {
          updateFuelTank(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Locations
  public addLocation<T = any>(
    command: AddLocation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddLocation',
      AddLocationMutation,
      AddLocationMutationVariables,
      T
    >({
      name: 'AddLocation',
      mutation: gql`
        mutation AddLocationMutation($command: AddLocation!) {
          addLocation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteLocation<T = any>(
    command: DeleteLocation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteLocation',
      DeleteLocationMutation,
      DeleteLocationMutationVariables,
      T
    >({
      name: 'DeleteLocation',
      mutation: gql`
        mutation DeleteLocationMutation($command: DeleteLocation!) {
          deleteLocation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public refreshLocationsFromGMRWorkday<T = any>(
    command: RefreshLocationsFromGMRWorkday,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RefreshLocationsFromGMRWorkday',
      RefreshLocationsFromGMRWorkdayMutation,
      RefreshLocationsFromGMRWorkdayMutationVariables,
      T
    >({
      name: 'RefreshLocationsFromGMRWorkday',
      mutation: gql`
        mutation RefreshLocationsFromGMRWorkdayMutation($command: RefreshLocationsFromGMRWorkday!) {
          refreshLocationsFromGMRWorkday(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateLocation<T = any>(
    command: UpdateLocation,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateLocation',
      UpdateLocationMutation,
      UpdateLocationMutationVariables,
      T
    >({
      name: 'UpdateLocation',
      mutation: gql`
        mutation UpdateLocationMutation($command: UpdateLocation!) {
          updateLocation(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // MaintenanceFacilities
  public addMaintenanceFacility<T = any>(
    command: AddMaintenanceFacility,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddMaintenanceFacility',
      AddMaintenanceFacilityMutation,
      AddMaintenanceFacilityMutationVariables,
      T
    >({
      name: 'AddMaintenanceFacility',
      mutation: gql`
        mutation AddMaintenanceFacilityMutation($command: AddMaintenanceFacility!) {
          addMaintenanceFacility(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteMaintenanceFacility<T = any>(
    command: DeleteMaintenanceFacility,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteMaintenanceFacility',
      DeleteMaintenanceFacilityMutation,
      DeleteMaintenanceFacilityMutationVariables,
      T
    >({
      name: 'DeleteMaintenanceFacility',
      mutation: gql`
        mutation DeleteMaintenanceFacilityMutation($command: DeleteMaintenanceFacility!) {
          deleteMaintenanceFacility(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateMaintenanceFacility<T = any>(
    command: UpdateMaintenanceFacility,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateMaintenanceFacility',
      UpdateMaintenanceFacilityMutation,
      UpdateMaintenanceFacilityMutationVariables,
      T
    >({
      name: 'UpdateMaintenanceFacility',
      mutation: gql`
        mutation UpdateMaintenanceFacilityMutation($command: UpdateMaintenanceFacility!) {
          updateMaintenanceFacility(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // MedicalFacilities
  public addMedicalFacility<T = any>(
    command: AddMedicalFacility,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddMedicalFacility',
      AddMedicalFacilityMutation,
      AddMedicalFacilityMutationVariables,
      T
    >({
      name: 'AddMedicalFacility',
      mutation: gql`
        mutation AddMedicalFacilityMutation($command: AddMedicalFacility!) {
          addMedicalFacility(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public approveMedicalFacility<T = any>(
    command: ApproveMedicalFacility,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ApproveMedicalFacility',
      ApproveMedicalFacilityMutation,
      ApproveMedicalFacilityMutationVariables,
      T
    >({
      name: 'ApproveMedicalFacility',
      mutation: gql`
        mutation ApproveMedicalFacilityMutation($command: ApproveMedicalFacility!) {
          approveMedicalFacility(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public archiveMedicalFacility<T = any>(
    command: ArchiveMedicalFacility,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ArchiveMedicalFacility',
      ArchiveMedicalFacilityMutation,
      ArchiveMedicalFacilityMutationVariables,
      T
    >({
      name: 'ArchiveMedicalFacility',
      mutation: gql`
        mutation ArchiveMedicalFacilityMutation($command: ArchiveMedicalFacility!) {
          archiveMedicalFacility(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public clearPendingArchiveMedicalFacility<T = any>(
    command: ClearPendingArchiveMedicalFacility,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ClearPendingArchiveMedicalFacility',
      ClearPendingArchiveMedicalFacilityMutation,
      ClearPendingArchiveMedicalFacilityMutationVariables,
      T
    >({
      name: 'ClearPendingArchiveMedicalFacility',
      mutation: gql`
        mutation ClearPendingArchiveMedicalFacilityMutation(
          $command: ClearPendingArchiveMedicalFacility!
        ) {
          clearPendingArchiveMedicalFacility(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteMedicalFacility<T = any>(
    command: DeleteMedicalFacility,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteMedicalFacility',
      DeleteMedicalFacilityMutation,
      DeleteMedicalFacilityMutationVariables,
      T
    >({
      name: 'DeleteMedicalFacility',
      mutation: gql`
        mutation DeleteMedicalFacilityMutation($command: DeleteMedicalFacility!) {
          deleteMedicalFacility(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public mergeMedicalFacilities<T = any>(
    command: MergeMedicalFacilities,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'MergeMedicalFacilities',
      MergeMedicalFacilitiesMutation,
      MergeMedicalFacilitiesMutationVariables,
      T
    >({
      name: 'MergeMedicalFacilities',
      mutation: gql`
        mutation MergeMedicalFacilitiesMutation($command: MergeMedicalFacilities!) {
          mergeMedicalFacilities(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public submitMedicalFacilityForApproval<T = any>(
    command: SubmitMedicalFacilityForApproval,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SubmitMedicalFacilityForApproval',
      SubmitMedicalFacilityForApprovalMutation,
      SubmitMedicalFacilityForApprovalMutationVariables,
      T
    >({
      name: 'SubmitMedicalFacilityForApproval',
      mutation: gql`
        mutation SubmitMedicalFacilityForApprovalMutation(
          $command: SubmitMedicalFacilityForApproval!
        ) {
          submitMedicalFacilityForApproval(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public unmarkMedicalFacilityAsDuplicate<T = any>(
    command: UnmarkMedicalFacilityAsDuplicate,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UnmarkMedicalFacilityAsDuplicate',
      UnmarkMedicalFacilityAsDuplicateMutation,
      UnmarkMedicalFacilityAsDuplicateMutationVariables,
      T
    >({
      name: 'UnmarkMedicalFacilityAsDuplicate',
      mutation: gql`
        mutation UnmarkMedicalFacilityAsDuplicateMutation(
          $command: UnmarkMedicalFacilityAsDuplicate!
        ) {
          unmarkMedicalFacilityAsDuplicate(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateMedicalFacility<T = any>(
    command: UpdateMedicalFacility,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateMedicalFacility',
      UpdateMedicalFacilityMutation,
      UpdateMedicalFacilityMutationVariables,
      T
    >({
      name: 'UpdateMedicalFacility',
      mutation: gql`
        mutation UpdateMedicalFacilityMutation($command: UpdateMedicalFacility!) {
          updateMedicalFacility(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateMedicalFacilityCustomIdentifiers<T = any>(
    command: UpdateMedicalFacilityCustomIdentifiers,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateMedicalFacilityCustomIdentifiers',
      UpdateMedicalFacilityCustomIdentifiersMutation,
      UpdateMedicalFacilityCustomIdentifiersMutationVariables,
      T
    >({
      name: 'UpdateMedicalFacilityCustomIdentifiers',
      mutation: gql`
        mutation UpdateMedicalFacilityCustomIdentifiersMutation(
          $command: UpdateMedicalFacilityCustomIdentifiers!
        ) {
          updateMedicalFacilityCustomIdentifiers(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // MedicalFacilityContacts
  public addMedicalFacilityContact<T = any>(
    command: AddMedicalFacilityContact,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddMedicalFacilityContact',
      AddMedicalFacilityContactMutation,
      AddMedicalFacilityContactMutationVariables,
      T
    >({
      name: 'AddMedicalFacilityContact',
      mutation: gql`
        mutation AddMedicalFacilityContactMutation($command: AddMedicalFacilityContact!) {
          addMedicalFacilityContact(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteMedicalFacilityContact<T = any>(
    command: DeleteMedicalFacilityContact,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteMedicalFacilityContact',
      DeleteMedicalFacilityContactMutation,
      DeleteMedicalFacilityContactMutationVariables,
      T
    >({
      name: 'DeleteMedicalFacilityContact',
      mutation: gql`
        mutation DeleteMedicalFacilityContactMutation($command: DeleteMedicalFacilityContact!) {
          deleteMedicalFacilityContact(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateMedicalFacilityContact<T = any>(
    command: UpdateMedicalFacilityContact,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateMedicalFacilityContact',
      UpdateMedicalFacilityContactMutation,
      UpdateMedicalFacilityContactMutationVariables,
      T
    >({
      name: 'UpdateMedicalFacilityContact',
      mutation: gql`
        mutation UpdateMedicalFacilityContactMutation($command: UpdateMedicalFacilityContact!) {
          updateMedicalFacilityContact(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // MedicalFacilityPhysicians
  public addMedicalFacilityPhysician<T = any>(
    command: AddMedicalFacilityPhysician,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddMedicalFacilityPhysician',
      AddMedicalFacilityPhysicianMutation,
      AddMedicalFacilityPhysicianMutationVariables,
      T
    >({
      name: 'AddMedicalFacilityPhysician',
      mutation: gql`
        mutation AddMedicalFacilityPhysicianMutation($command: AddMedicalFacilityPhysician!) {
          addMedicalFacilityPhysician(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteMedicalFacilityPhysician<T = any>(
    command: DeleteMedicalFacilityPhysician,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteMedicalFacilityPhysician',
      DeleteMedicalFacilityPhysicianMutation,
      DeleteMedicalFacilityPhysicianMutationVariables,
      T
    >({
      name: 'DeleteMedicalFacilityPhysician',
      mutation: gql`
        mutation DeleteMedicalFacilityPhysicianMutation($command: DeleteMedicalFacilityPhysician!) {
          deleteMedicalFacilityPhysician(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateMedicalFacilityPhysician<T = any>(
    command: UpdateMedicalFacilityPhysician,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateMedicalFacilityPhysician',
      UpdateMedicalFacilityPhysicianMutation,
      UpdateMedicalFacilityPhysicianMutationVariables,
      T
    >({
      name: 'UpdateMedicalFacilityPhysician',
      mutation: gql`
        mutation UpdateMedicalFacilityPhysicianMutation($command: UpdateMedicalFacilityPhysician!) {
          updateMedicalFacilityPhysician(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // MedicalFacilityUnits
  public addMedicalFacilityUnit<T = any>(
    command: AddMedicalFacilityUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddMedicalFacilityUnit',
      AddMedicalFacilityUnitMutation,
      AddMedicalFacilityUnitMutationVariables,
      T
    >({
      name: 'AddMedicalFacilityUnit',
      mutation: gql`
        mutation AddMedicalFacilityUnitMutation($command: AddMedicalFacilityUnit!) {
          addMedicalFacilityUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteMedicalFacilityUnit<T = any>(
    command: DeleteMedicalFacilityUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteMedicalFacilityUnit',
      DeleteMedicalFacilityUnitMutation,
      DeleteMedicalFacilityUnitMutationVariables,
      T
    >({
      name: 'DeleteMedicalFacilityUnit',
      mutation: gql`
        mutation DeleteMedicalFacilityUnitMutation($command: DeleteMedicalFacilityUnit!) {
          deleteMedicalFacilityUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateMedicalFacilityUnit<T = any>(
    command: UpdateMedicalFacilityUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateMedicalFacilityUnit',
      UpdateMedicalFacilityUnitMutation,
      UpdateMedicalFacilityUnitMutationVariables,
      T
    >({
      name: 'UpdateMedicalFacilityUnit',
      mutation: gql`
        mutation UpdateMedicalFacilityUnitMutation($command: UpdateMedicalFacilityUnit!) {
          updateMedicalFacilityUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // OrgApplicationStarts
  // OutOfServiceQARReasons
  public addOutOfServiceQARReason<T = any>(
    command: AddOutOfServiceQARReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOutOfServiceQARReason',
      AddOutOfServiceQARReasonMutation,
      AddOutOfServiceQARReasonMutationVariables,
      T
    >({
      name: 'AddOutOfServiceQARReason',
      mutation: gql`
        mutation AddOutOfServiceQARReasonMutation($command: AddOutOfServiceQARReason!) {
          addOutOfServiceQARReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteOutOfServiceQARReason<T = any>(
    command: DeleteOutOfServiceQARReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteOutOfServiceQARReason',
      DeleteOutOfServiceQARReasonMutation,
      DeleteOutOfServiceQARReasonMutationVariables,
      T
    >({
      name: 'DeleteOutOfServiceQARReason',
      mutation: gql`
        mutation DeleteOutOfServiceQARReasonMutation($command: DeleteOutOfServiceQARReason!) {
          deleteOutOfServiceQARReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOutOfServiceQARReason<T = any>(
    command: UpdateOutOfServiceQARReason,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOutOfServiceQARReason',
      UpdateOutOfServiceQARReasonMutation,
      UpdateOutOfServiceQARReasonMutationVariables,
      T
    >({
      name: 'UpdateOutOfServiceQARReason',
      mutation: gql`
        mutation UpdateOutOfServiceQARReasonMutation($command: UpdateOutOfServiceQARReason!) {
          updateOutOfServiceQARReason(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // People
  public addOutOfComplianceCrewMember<T = any>(
    command: AddOutOfComplianceCrewMember,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddOutOfComplianceCrewMember',
      AddOutOfComplianceCrewMemberMutation,
      AddOutOfComplianceCrewMemberMutationVariables,
      T
    >({
      name: 'AddOutOfComplianceCrewMember',
      mutation: gql`
        mutation AddOutOfComplianceCrewMemberMutation($command: AddOutOfComplianceCrewMember!) {
          addOutOfComplianceCrewMember(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addPerson<T = any>(
    command: AddPerson,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddPerson', AddPersonMutation, AddPersonMutationVariables, T>({
      name: 'AddPerson',
      mutation: gql`
        mutation AddPersonMutation($command: AddPerson!) {
          addPerson(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addPersonAdditionalCompany<T = any>(
    command: AddPersonAdditionalCompany,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddPersonAdditionalCompany',
      AddPersonAdditionalCompanyMutation,
      AddPersonAdditionalCompanyMutationVariables,
      T
    >({
      name: 'AddPersonAdditionalCompany',
      mutation: gql`
        mutation AddPersonAdditionalCompanyMutation($command: AddPersonAdditionalCompany!) {
          addPersonAdditionalCompany(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public authorizeClientSyncAccess<T = any>(
    command: AuthorizeClientSyncAccess,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AuthorizeClientSyncAccess',
      AuthorizeClientSyncAccessMutation,
      AuthorizeClientSyncAccessMutationVariables,
      T
    >({
      name: 'AuthorizeClientSyncAccess',
      mutation: gql`
        mutation AuthorizeClientSyncAccessMutation($command: AuthorizeClientSyncAccess!) {
          authorizeClientSyncAccess(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deletePerson<T = any>(
    command: DeletePerson,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeletePerson',
      DeletePersonMutation,
      DeletePersonMutationVariables,
      T
    >({
      name: 'DeletePerson',
      mutation: gql`
        mutation DeletePersonMutation($command: DeletePerson!) {
          deletePerson(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public grantClientSyncAccess<T = any>(
    command: GrantClientSyncAccess,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'GrantClientSyncAccess',
      GrantClientSyncAccessMutation,
      GrantClientSyncAccessMutationVariables,
      T
    >({
      name: 'GrantClientSyncAccess',
      mutation: gql`
        mutation GrantClientSyncAccessMutation($command: GrantClientSyncAccess!) {
          grantClientSyncAccess(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public refreshPeopleFromGMRWorkdayV2<T = any>(
    command: RefreshPeopleFromGMRWorkdayV2,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RefreshPeopleFromGMRWorkdayV2',
      RefreshPeopleFromGMRWorkdayV2Mutation,
      RefreshPeopleFromGMRWorkdayV2MutationVariables,
      T
    >({
      name: 'RefreshPeopleFromGMRWorkdayV2',
      mutation: gql`
        mutation RefreshPeopleFromGMRWorkdayV2Mutation($command: RefreshPeopleFromGMRWorkdayV2!) {
          refreshPeopleFromGMRWorkdayV2(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public removeCrewMemberFromOutOfCompliance<T = any>(
    command: RemoveCrewMemberFromOutOfCompliance,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RemoveCrewMemberFromOutOfCompliance',
      RemoveCrewMemberFromOutOfComplianceMutation,
      RemoveCrewMemberFromOutOfComplianceMutationVariables,
      T
    >({
      name: 'RemoveCrewMemberFromOutOfCompliance',
      mutation: gql`
        mutation RemoveCrewMemberFromOutOfComplianceMutation(
          $command: RemoveCrewMemberFromOutOfCompliance!
        ) {
          removeCrewMemberFromOutOfCompliance(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public removePersonAdditionalCompany<T = any>(
    command: RemovePersonAdditionalCompany,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RemovePersonAdditionalCompany',
      RemovePersonAdditionalCompanyMutation,
      RemovePersonAdditionalCompanyMutationVariables,
      T
    >({
      name: 'RemovePersonAdditionalCompany',
      mutation: gql`
        mutation RemovePersonAdditionalCompanyMutation($command: RemovePersonAdditionalCompany!) {
          removePersonAdditionalCompany(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public resetPassword<T = any>(
    command: ResetPassword,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ResetPassword',
      ResetPasswordMutation,
      ResetPasswordMutationVariables,
      T
    >({
      name: 'ResetPassword',
      mutation: gql`
        mutation ResetPasswordMutation($command: ResetPassword!) {
          resetPassword(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public setRoleScope<T = any>(
    command: SetRoleScope,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SetRoleScope',
      SetRoleScopeMutation,
      SetRoleScopeMutationVariables,
      T
    >({
      name: 'SetRoleScope',
      mutation: gql`
        mutation SetRoleScopeMutation($command: SetRoleScope!) {
          setRoleScope(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateOutOfComplianceCrewMember<T = any>(
    command: UpdateOutOfComplianceCrewMember,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateOutOfComplianceCrewMember',
      UpdateOutOfComplianceCrewMemberMutation,
      UpdateOutOfComplianceCrewMemberMutationVariables,
      T
    >({
      name: 'UpdateOutOfComplianceCrewMember',
      mutation: gql`
        mutation UpdateOutOfComplianceCrewMemberMutation(
          $command: UpdateOutOfComplianceCrewMember!
        ) {
          updateOutOfComplianceCrewMember(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updatePerson<T = any>(
    command: UpdatePerson,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePerson',
      UpdatePersonMutation,
      UpdatePersonMutationVariables,
      T
    >({
      name: 'UpdatePerson',
      mutation: gql`
        mutation UpdatePersonMutation($command: UpdatePerson!) {
          updatePerson(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTcsRealtimeTrackingTab<T = any>(
    command: UpdateTcsRealtimeTrackingTab,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTcsRealtimeTrackingTab',
      UpdateTcsRealtimeTrackingTabMutation,
      UpdateTcsRealtimeTrackingTabMutationVariables,
      T
    >({
      name: 'UpdateTcsRealtimeTrackingTab',
      mutation: gql`
        mutation UpdateTcsRealtimeTrackingTabMutation($command: UpdateTcsRealtimeTrackingTab!) {
          updateTcsRealtimeTrackingTab(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Physicians
  public addPhysician<T = any>(
    command: AddPhysician,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddPhysician',
      AddPhysicianMutation,
      AddPhysicianMutationVariables,
      T
    >({
      name: 'AddPhysician',
      mutation: gql`
        mutation AddPhysicianMutation($command: AddPhysician!) {
          addPhysician(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deletePhysician<T = any>(
    command: DeletePhysician,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeletePhysician',
      DeletePhysicianMutation,
      DeletePhysicianMutationVariables,
      T
    >({
      name: 'DeletePhysician',
      mutation: gql`
        mutation DeletePhysicianMutation($command: DeletePhysician!) {
          deletePhysician(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updatePhysician<T = any>(
    command: UpdatePhysician,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdatePhysician',
      UpdatePhysicianMutation,
      UpdatePhysicianMutationVariables,
      T
    >({
      name: 'UpdatePhysician',
      mutation: gql`
        mutation UpdatePhysicianMutation($command: UpdatePhysician!) {
          updatePhysician(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ProgramBases
  public addProgramBase<T = any>(
    command: AddProgramBase,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddProgramBase',
      AddProgramBaseMutation,
      AddProgramBaseMutationVariables,
      T
    >({
      name: 'AddProgramBase',
      mutation: gql`
        mutation AddProgramBaseMutation($command: AddProgramBase!) {
          addProgramBase(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteProgramBase<T = any>(
    command: DeleteProgramBase,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteProgramBase',
      DeleteProgramBaseMutation,
      DeleteProgramBaseMutationVariables,
      T
    >({
      name: 'DeleteProgramBase',
      mutation: gql`
        mutation DeleteProgramBaseMutation($command: DeleteProgramBase!) {
          deleteProgramBase(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateProgramBase<T = any>(
    command: UpdateProgramBase,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateProgramBase',
      UpdateProgramBaseMutation,
      UpdateProgramBaseMutationVariables,
      T
    >({
      name: 'UpdateProgramBase',
      mutation: gql`
        mutation UpdateProgramBaseMutation($command: UpdateProgramBase!) {
          updateProgramBase(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Programs
  public addProgram<T = any>(
    command: AddProgram,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddProgram', AddProgramMutation, AddProgramMutationVariables, T>(
      {
        name: 'AddProgram',
        mutation: gql`
          mutation AddProgramMutation($command: AddProgram!) {
            addProgram(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public deleteProgram<T = any>(
    command: DeleteProgram,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteProgram',
      DeleteProgramMutation,
      DeleteProgramMutationVariables,
      T
    >({
      name: 'DeleteProgram',
      mutation: gql`
        mutation DeleteProgramMutation($command: DeleteProgram!) {
          deleteProgram(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateProgram<T = any>(
    command: UpdateProgram,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateProgram',
      UpdateProgramMutation,
      UpdateProgramMutationVariables,
      T
    >({
      name: 'UpdateProgram',
      mutation: gql`
        mutation UpdateProgramMutation($command: UpdateProgram!) {
          updateProgram(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // RamcoVehicleConfigurations
  // RegionBases
  public addRegionBase<T = any>(
    command: AddRegionBase,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddRegionBase',
      AddRegionBaseMutation,
      AddRegionBaseMutationVariables,
      T
    >({
      name: 'AddRegionBase',
      mutation: gql`
        mutation AddRegionBaseMutation($command: AddRegionBase!) {
          addRegionBase(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteRegionBase<T = any>(
    command: DeleteRegionBase,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteRegionBase',
      DeleteRegionBaseMutation,
      DeleteRegionBaseMutationVariables,
      T
    >({
      name: 'DeleteRegionBase',
      mutation: gql`
        mutation DeleteRegionBaseMutation($command: DeleteRegionBase!) {
          deleteRegionBase(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRegionBase<T = any>(
    command: UpdateRegionBase,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRegionBase',
      UpdateRegionBaseMutation,
      UpdateRegionBaseMutationVariables,
      T
    >({
      name: 'UpdateRegionBase',
      mutation: gql`
        mutation UpdateRegionBaseMutation($command: UpdateRegionBase!) {
          updateRegionBase(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // RegionGroups
  public addRegionGroup<T = any>(
    command: AddRegionGroup,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddRegionGroup',
      AddRegionGroupMutation,
      AddRegionGroupMutationVariables,
      T
    >({
      name: 'AddRegionGroup',
      mutation: gql`
        mutation AddRegionGroupMutation($command: AddRegionGroup!) {
          addRegionGroup(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteRegionGroup<T = any>(
    command: DeleteRegionGroup,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteRegionGroup',
      DeleteRegionGroupMutation,
      DeleteRegionGroupMutationVariables,
      T
    >({
      name: 'DeleteRegionGroup',
      mutation: gql`
        mutation DeleteRegionGroupMutation($command: DeleteRegionGroup!) {
          deleteRegionGroup(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRegionGroup<T = any>(
    command: UpdateRegionGroup,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRegionGroup',
      UpdateRegionGroupMutation,
      UpdateRegionGroupMutationVariables,
      T
    >({
      name: 'UpdateRegionGroup',
      mutation: gql`
        mutation UpdateRegionGroupMutation($command: UpdateRegionGroup!) {
          updateRegionGroup(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Regions
  public addRegion<T = any>(
    command: AddRegion,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddRegion', AddRegionMutation, AddRegionMutationVariables, T>({
      name: 'AddRegion',
      mutation: gql`
        mutation AddRegionMutation($command: AddRegion!) {
          addRegion(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addTransferCenterRegion<T = any>(
    command: AddTransferCenterRegion,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTransferCenterRegion',
      AddTransferCenterRegionMutation,
      AddTransferCenterRegionMutationVariables,
      T
    >({
      name: 'AddTransferCenterRegion',
      mutation: gql`
        mutation AddTransferCenterRegionMutation($command: AddTransferCenterRegion!) {
          addTransferCenterRegion(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteRegion<T = any>(
    command: DeleteRegion,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteRegion',
      DeleteRegionMutation,
      DeleteRegionMutationVariables,
      T
    >({
      name: 'DeleteRegion',
      mutation: gql`
        mutation DeleteRegionMutation($command: DeleteRegion!) {
          deleteRegion(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateRegion<T = any>(
    command: UpdateRegion,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateRegion',
      UpdateRegionMutation,
      UpdateRegionMutationVariables,
      T
    >({
      name: 'UpdateRegion',
      mutation: gql`
        mutation UpdateRegionMutation($command: UpdateRegion!) {
          updateRegion(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // ReleaseNotes
  public addReleaseNote<T = any>(
    command: AddReleaseNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddReleaseNote',
      AddReleaseNoteMutation,
      AddReleaseNoteMutationVariables,
      T
    >({
      name: 'AddReleaseNote',
      mutation: gql`
        mutation AddReleaseNoteMutation($command: AddReleaseNote!) {
          addReleaseNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteReleaseNote<T = any>(
    command: DeleteReleaseNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteReleaseNote',
      DeleteReleaseNoteMutation,
      DeleteReleaseNoteMutationVariables,
      T
    >({
      name: 'DeleteReleaseNote',
      mutation: gql`
        mutation DeleteReleaseNoteMutation($command: DeleteReleaseNote!) {
          deleteReleaseNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateReleaseNote<T = any>(
    command: UpdateReleaseNote,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateReleaseNote',
      UpdateReleaseNoteMutation,
      UpdateReleaseNoteMutationVariables,
      T
    >({
      name: 'UpdateReleaseNote',
      mutation: gql`
        mutation UpdateReleaseNoteMutation($command: UpdateReleaseNote!) {
          updateReleaseNote(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // SpecialtyTeamMembers
  public addExistingSpecialtyTeamMember<T = any>(
    command: AddExistingSpecialtyTeamMember,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddExistingSpecialtyTeamMember',
      AddExistingSpecialtyTeamMemberMutation,
      AddExistingSpecialtyTeamMemberMutationVariables,
      T
    >({
      name: 'AddExistingSpecialtyTeamMember',
      mutation: gql`
        mutation AddExistingSpecialtyTeamMemberMutation($command: AddExistingSpecialtyTeamMember!) {
          addExistingSpecialtyTeamMember(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public addSpecialtyTeamMember<T = any>(
    command: AddSpecialtyTeamMember,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddSpecialtyTeamMember',
      AddSpecialtyTeamMemberMutation,
      AddSpecialtyTeamMemberMutationVariables,
      T
    >({
      name: 'AddSpecialtyTeamMember',
      mutation: gql`
        mutation AddSpecialtyTeamMemberMutation($command: AddSpecialtyTeamMember!) {
          addSpecialtyTeamMember(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteSpecialtyTeamMember<T = any>(
    command: DeleteSpecialtyTeamMember,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteSpecialtyTeamMember',
      DeleteSpecialtyTeamMemberMutation,
      DeleteSpecialtyTeamMemberMutationVariables,
      T
    >({
      name: 'DeleteSpecialtyTeamMember',
      mutation: gql`
        mutation DeleteSpecialtyTeamMemberMutation($command: DeleteSpecialtyTeamMember!) {
          deleteSpecialtyTeamMember(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateSpecialtyTeamMember<T = any>(
    command: UpdateSpecialtyTeamMember,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateSpecialtyTeamMember',
      UpdateSpecialtyTeamMemberMutation,
      UpdateSpecialtyTeamMemberMutationVariables,
      T
    >({
      name: 'UpdateSpecialtyTeamMember',
      mutation: gql`
        mutation UpdateSpecialtyTeamMemberMutation($command: UpdateSpecialtyTeamMember!) {
          updateSpecialtyTeamMember(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // SpecialtyTeams
  public addSpecialtyTeam<T = any>(
    command: AddSpecialtyTeam,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddSpecialtyTeam',
      AddSpecialtyTeamMutation,
      AddSpecialtyTeamMutationVariables,
      T
    >({
      name: 'AddSpecialtyTeam',
      mutation: gql`
        mutation AddSpecialtyTeamMutation($command: AddSpecialtyTeam!) {
          addSpecialtyTeam(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteSpecialtyTeam<T = any>(
    command: DeleteSpecialtyTeam,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteSpecialtyTeam',
      DeleteSpecialtyTeamMutation,
      DeleteSpecialtyTeamMutationVariables,
      T
    >({
      name: 'DeleteSpecialtyTeam',
      mutation: gql`
        mutation DeleteSpecialtyTeamMutation($command: DeleteSpecialtyTeam!) {
          deleteSpecialtyTeam(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateSpecialtyTeam<T = any>(
    command: UpdateSpecialtyTeam,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateSpecialtyTeam',
      UpdateSpecialtyTeamMutation,
      UpdateSpecialtyTeamMutationVariables,
      T
    >({
      name: 'UpdateSpecialtyTeam',
      mutation: gql`
        mutation UpdateSpecialtyTeamMutation($command: UpdateSpecialtyTeam!) {
          updateSpecialtyTeam(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // States
  public addState<T = any>(
    command: AddState,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddState', AddStateMutation, AddStateMutationVariables, T>({
      name: 'AddState',
      mutation: gql`
        mutation AddStateMutation($command: AddState!) {
          addState(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteState<T = any>(
    command: DeleteState,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteState',
      DeleteStateMutation,
      DeleteStateMutationVariables,
      T
    >({
      name: 'DeleteState',
      mutation: gql`
        mutation DeleteStateMutation($command: DeleteState!) {
          deleteState(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateState<T = any>(
    command: UpdateState,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateState',
      UpdateStateMutation,
      UpdateStateMutationVariables,
      T
    >({
      name: 'UpdateState',
      mutation: gql`
        mutation UpdateStateMutation($command: UpdateState!) {
          updateState(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // SupportRequests
  public addSupportRequest<T = any>(
    command: AddSupportRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddSupportRequest',
      AddSupportRequestMutation,
      AddSupportRequestMutationVariables,
      T
    >({
      name: 'AddSupportRequest',
      mutation: gql`
        mutation AddSupportRequestMutation($command: AddSupportRequest!) {
          addSupportRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteSupportRequest<T = any>(
    command: DeleteSupportRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteSupportRequest',
      DeleteSupportRequestMutation,
      DeleteSupportRequestMutationVariables,
      T
    >({
      name: 'DeleteSupportRequest',
      mutation: gql`
        mutation DeleteSupportRequestMutation($command: DeleteSupportRequest!) {
          deleteSupportRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public setSupportRequestState<T = any>(
    command: SetSupportRequestState,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SetSupportRequestState',
      SetSupportRequestStateMutation,
      SetSupportRequestStateMutationVariables,
      T
    >({
      name: 'SetSupportRequestState',
      mutation: gql`
        mutation SetSupportRequestStateMutation($command: SetSupportRequestState!) {
          setSupportRequestState(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public submitSupportRequest<T = any>(
    command: SubmitSupportRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SubmitSupportRequest',
      SubmitSupportRequestMutation,
      SubmitSupportRequestMutationVariables,
      T
    >({
      name: 'SubmitSupportRequest',
      mutation: gql`
        mutation SubmitSupportRequestMutation($command: SubmitSupportRequest!) {
          submitSupportRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateSupportRequest<T = any>(
    command: UpdateSupportRequest,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateSupportRequest',
      UpdateSupportRequestMutation,
      UpdateSupportRequestMutationVariables,
      T
    >({
      name: 'UpdateSupportRequest',
      mutation: gql`
        mutation UpdateSupportRequestMutation($command: UpdateSupportRequest!) {
          updateSupportRequest(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateSupportRequestEmailSent<T = any>(
    command: UpdateSupportRequestEmailSent,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateSupportRequestEmailSent',
      UpdateSupportRequestEmailSentMutation,
      UpdateSupportRequestEmailSentMutationVariables,
      T
    >({
      name: 'UpdateSupportRequestEmailSent',
      mutation: gql`
        mutation UpdateSupportRequestEmailSentMutation($command: UpdateSupportRequestEmailSent!) {
          updateSupportRequestEmailSent(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Timezones
  public addTimezone<T = any>(
    command: AddTimezone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTimezone',
      AddTimezoneMutation,
      AddTimezoneMutationVariables,
      T
    >({
      name: 'AddTimezone',
      mutation: gql`
        mutation AddTimezoneMutation($command: AddTimezone!) {
          addTimezone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTimezone<T = any>(
    command: DeleteTimezone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTimezone',
      DeleteTimezoneMutation,
      DeleteTimezoneMutationVariables,
      T
    >({
      name: 'DeleteTimezone',
      mutation: gql`
        mutation DeleteTimezoneMutation($command: DeleteTimezone!) {
          deleteTimezone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTimezone<T = any>(
    command: UpdateTimezone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTimezone',
      UpdateTimezoneMutation,
      UpdateTimezoneMutationVariables,
      T
    >({
      name: 'UpdateTimezone',
      mutation: gql`
        mutation UpdateTimezoneMutation($command: UpdateTimezone!) {
          updateTimezone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TransferCenters
  public addTransferCenter<T = any>(
    command: AddTransferCenter,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddTransferCenter',
      AddTransferCenterMutation,
      AddTransferCenterMutationVariables,
      T
    >({
      name: 'AddTransferCenter',
      mutation: gql`
        mutation AddTransferCenterMutation($command: AddTransferCenter!) {
          addTransferCenter(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTransferCenter<T = any>(
    command: DeleteTransferCenter,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTransferCenter',
      DeleteTransferCenterMutation,
      DeleteTransferCenterMutationVariables,
      T
    >({
      name: 'DeleteTransferCenter',
      mutation: gql`
        mutation DeleteTransferCenterMutation($command: DeleteTransferCenter!) {
          deleteTransferCenter(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTransferCenter<T = any>(
    command: UpdateTransferCenter,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTransferCenter',
      UpdateTransferCenterMutation,
      UpdateTransferCenterMutationVariables,
      T
    >({
      name: 'UpdateTransferCenter',
      mutation: gql`
        mutation UpdateTransferCenterMutation($command: UpdateTransferCenter!) {
          updateTransferCenter(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // TrmUserAgencies
  // TrmUserMedicalFacilities
  // TrmUserPrograms
  // TrmUsers
  public addPreApprovedTrmUser<T = any>(
    command: AddPreApprovedTrmUser,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddPreApprovedTrmUser',
      AddPreApprovedTrmUserMutation,
      AddPreApprovedTrmUserMutationVariables,
      T
    >({
      name: 'AddPreApprovedTrmUser',
      mutation: gql`
        mutation AddPreApprovedTrmUserMutation($command: AddPreApprovedTrmUser!) {
          addPreApprovedTrmUser(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public approveTrmUser<T = any>(
    command: ApproveTrmUser,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ApproveTrmUser',
      ApproveTrmUserMutation,
      ApproveTrmUserMutationVariables,
      T
    >({
      name: 'ApproveTrmUser',
      mutation: gql`
        mutation ApproveTrmUserMutation($command: ApproveTrmUser!) {
          approveTrmUser(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deactivateTrmUser<T = any>(
    command: DeactivateTrmUser,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeactivateTrmUser',
      DeactivateTrmUserMutation,
      DeactivateTrmUserMutationVariables,
      T
    >({
      name: 'DeactivateTrmUser',
      mutation: gql`
        mutation DeactivateTrmUserMutation($command: DeactivateTrmUser!) {
          deactivateTrmUser(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteTrmUser<T = any>(
    command: DeleteTrmUser,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteTrmUser',
      DeleteTrmUserMutation,
      DeleteTrmUserMutationVariables,
      T
    >({
      name: 'DeleteTrmUser',
      mutation: gql`
        mutation DeleteTrmUserMutation($command: DeleteTrmUser!) {
          deleteTrmUser(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public denyTrmUser<T = any>(
    command: DenyTrmUser,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DenyTrmUser',
      DenyTrmUserMutation,
      DenyTrmUserMutationVariables,
      T
    >({
      name: 'DenyTrmUser',
      mutation: gql`
        mutation DenyTrmUserMutation($command: DenyTrmUser!) {
          denyTrmUser(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public registerTrmUser<T = any>(
    command: RegisterTrmUser,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'RegisterTrmUser',
      RegisterTrmUserMutation,
      RegisterTrmUserMutationVariables,
      T
    >({
      name: 'RegisterTrmUser',
      mutation: gql`
        mutation RegisterTrmUserMutation($command: RegisterTrmUser!) {
          registerTrmUser(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateTrmUser<T = any>(
    command: UpdateTrmUser,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateTrmUser',
      UpdateTrmUserMutation,
      UpdateTrmUserMutationVariables,
      T
    >({
      name: 'UpdateTrmUser',
      mutation: gql`
        mutation UpdateTrmUserMutation($command: UpdateTrmUser!) {
          updateTrmUser(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // VehicleConfigurationClasses
  public addVehicleConfigurationClass<T = any>(
    command: AddVehicleConfigurationClass,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddVehicleConfigurationClass',
      AddVehicleConfigurationClassMutation,
      AddVehicleConfigurationClassMutationVariables,
      T
    >({
      name: 'AddVehicleConfigurationClass',
      mutation: gql`
        mutation AddVehicleConfigurationClassMutation($command: AddVehicleConfigurationClass!) {
          addVehicleConfigurationClass(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteVehicleConfigurationClass<T = any>(
    command: DeleteVehicleConfigurationClass,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteVehicleConfigurationClass',
      DeleteVehicleConfigurationClassMutation,
      DeleteVehicleConfigurationClassMutationVariables,
      T
    >({
      name: 'DeleteVehicleConfigurationClass',
      mutation: gql`
        mutation DeleteVehicleConfigurationClassMutation(
          $command: DeleteVehicleConfigurationClass!
        ) {
          deleteVehicleConfigurationClass(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateVehicleConfigurationClass<T = any>(
    command: UpdateVehicleConfigurationClass,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateVehicleConfigurationClass',
      UpdateVehicleConfigurationClassMutation,
      UpdateVehicleConfigurationClassMutationVariables,
      T
    >({
      name: 'UpdateVehicleConfigurationClass',
      mutation: gql`
        mutation UpdateVehicleConfigurationClassMutation(
          $command: UpdateVehicleConfigurationClass!
        ) {
          updateVehicleConfigurationClass(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // VehicleControlZones
  public addVehicleControlZone<T = any>(
    command: AddVehicleControlZone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddVehicleControlZone',
      AddVehicleControlZoneMutation,
      AddVehicleControlZoneMutationVariables,
      T
    >({
      name: 'AddVehicleControlZone',
      mutation: gql`
        mutation AddVehicleControlZoneMutation($command: AddVehicleControlZone!) {
          addVehicleControlZone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteVehicleControlZone<T = any>(
    command: DeleteVehicleControlZone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteVehicleControlZone',
      DeleteVehicleControlZoneMutation,
      DeleteVehicleControlZoneMutationVariables,
      T
    >({
      name: 'DeleteVehicleControlZone',
      mutation: gql`
        mutation DeleteVehicleControlZoneMutation($command: DeleteVehicleControlZone!) {
          deleteVehicleControlZone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateVehicleControlZone<T = any>(
    command: UpdateVehicleControlZone,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateVehicleControlZone',
      UpdateVehicleControlZoneMutation,
      UpdateVehicleControlZoneMutationVariables,
      T
    >({
      name: 'UpdateVehicleControlZone',
      mutation: gql`
        mutation UpdateVehicleControlZoneMutation($command: UpdateVehicleControlZone!) {
          updateVehicleControlZone(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // VehicleMaintenances
  public addVehicleMaintenance<T = any>(
    command: AddVehicleMaintenance,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddVehicleMaintenance',
      AddVehicleMaintenanceMutation,
      AddVehicleMaintenanceMutationVariables,
      T
    >({
      name: 'AddVehicleMaintenance',
      mutation: gql`
        mutation AddVehicleMaintenanceMutation($command: AddVehicleMaintenance!) {
          addVehicleMaintenance(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteVehicleMaintenance<T = any>(
    command: DeleteVehicleMaintenance,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteVehicleMaintenance',
      DeleteVehicleMaintenanceMutation,
      DeleteVehicleMaintenanceMutationVariables,
      T
    >({
      name: 'DeleteVehicleMaintenance',
      mutation: gql`
        mutation DeleteVehicleMaintenanceMutation($command: DeleteVehicleMaintenance!) {
          deleteVehicleMaintenance(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateVehicleMaintenance<T = any>(
    command: UpdateVehicleMaintenance,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateVehicleMaintenance',
      UpdateVehicleMaintenanceMutation,
      UpdateVehicleMaintenanceMutationVariables,
      T
    >({
      name: 'UpdateVehicleMaintenance',
      mutation: gql`
        mutation UpdateVehicleMaintenanceMutation($command: UpdateVehicleMaintenance!) {
          updateVehicleMaintenance(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public upsertVehicleMaintenanceParameters<T = any>(
    command: UpsertVehicleMaintenanceParameters,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpsertVehicleMaintenanceParameters',
      UpsertVehicleMaintenanceParametersMutation,
      UpsertVehicleMaintenanceParametersMutationVariables,
      T
    >({
      name: 'UpsertVehicleMaintenanceParameters',
      mutation: gql`
        mutation UpsertVehicleMaintenanceParametersMutation(
          $command: UpsertVehicleMaintenanceParameters!
        ) {
          upsertVehicleMaintenanceParameters(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // VehicleMakes
  public addVehicleMake<T = any>(
    command: AddVehicleMake,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddVehicleMake',
      AddVehicleMakeMutation,
      AddVehicleMakeMutationVariables,
      T
    >({
      name: 'AddVehicleMake',
      mutation: gql`
        mutation AddVehicleMakeMutation($command: AddVehicleMake!) {
          addVehicleMake(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteVehicleMake<T = any>(
    command: DeleteVehicleMake,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteVehicleMake',
      DeleteVehicleMakeMutation,
      DeleteVehicleMakeMutationVariables,
      T
    >({
      name: 'DeleteVehicleMake',
      mutation: gql`
        mutation DeleteVehicleMakeMutation($command: DeleteVehicleMake!) {
          deleteVehicleMake(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateVehicleMake<T = any>(
    command: UpdateVehicleMake,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateVehicleMake',
      UpdateVehicleMakeMutation,
      UpdateVehicleMakeMutationVariables,
      T
    >({
      name: 'UpdateVehicleMake',
      mutation: gql`
        mutation UpdateVehicleMakeMutation($command: UpdateVehicleMake!) {
          updateVehicleMake(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // VehicleModels
  public addVehicleModel<T = any>(
    command: AddVehicleModel,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddVehicleModel',
      AddVehicleModelMutation,
      AddVehicleModelMutationVariables,
      T
    >({
      name: 'AddVehicleModel',
      mutation: gql`
        mutation AddVehicleModelMutation($command: AddVehicleModel!) {
          addVehicleModel(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteVehicleModel<T = any>(
    command: DeleteVehicleModel,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteVehicleModel',
      DeleteVehicleModelMutation,
      DeleteVehicleModelMutationVariables,
      T
    >({
      name: 'DeleteVehicleModel',
      mutation: gql`
        mutation DeleteVehicleModelMutation($command: DeleteVehicleModel!) {
          deleteVehicleModel(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateVehicleModel<T = any>(
    command: UpdateVehicleModel,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateVehicleModel',
      UpdateVehicleModelMutation,
      UpdateVehicleModelMutationVariables,
      T
    >({
      name: 'UpdateVehicleModel',
      mutation: gql`
        mutation UpdateVehicleModelMutation($command: UpdateVehicleModel!) {
          updateVehicleModel(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // Vehicles
  public addVehicle<T = any>(
    command: AddVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<'AddVehicle', AddVehicleMutation, AddVehicleMutationVariables, T>(
      {
        name: 'AddVehicle',
        mutation: gql`
          mutation AddVehicleMutation($command: AddVehicle!) {
            addVehicle(command: $command) {
              status
              data
              command
              emittedEvents
              entities
              errors {
                message
                code
              }
            }
          }
        `,
        variables: { command },
        options,
      },
    );
  }
  public changeVehicleFlightLogProcess<T = any>(
    command: ChangeVehicleFlightLogProcess,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'ChangeVehicleFlightLogProcess',
      ChangeVehicleFlightLogProcessMutation,
      ChangeVehicleFlightLogProcessMutationVariables,
      T
    >({
      name: 'ChangeVehicleFlightLogProcess',
      mutation: gql`
        mutation ChangeVehicleFlightLogProcessMutation($command: ChangeVehicleFlightLogProcess!) {
          changeVehicleFlightLogProcess(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteVehicle<T = any>(
    command: DeleteVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteVehicle',
      DeleteVehicleMutation,
      DeleteVehicleMutationVariables,
      T
    >({
      name: 'DeleteVehicle',
      mutation: gql`
        mutation DeleteVehicleMutation($command: DeleteVehicle!) {
          deleteVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public ensureThirdPartyVehicleAndUnit<T = any>(
    command: EnsureThirdPartyVehicleAndUnit,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'EnsureThirdPartyVehicleAndUnit',
      EnsureThirdPartyVehicleAndUnitMutation,
      EnsureThirdPartyVehicleAndUnitMutationVariables,
      T
    >({
      name: 'EnsureThirdPartyVehicleAndUnit',
      mutation: gql`
        mutation EnsureThirdPartyVehicleAndUnitMutation($command: EnsureThirdPartyVehicleAndUnit!) {
          ensureThirdPartyVehicleAndUnit(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public hideVehicle<T = any>(
    command: HideVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'HideVehicle',
      HideVehicleMutation,
      HideVehicleMutationVariables,
      T
    >({
      name: 'HideVehicle',
      mutation: gql`
        mutation HideVehicleMutation($command: HideVehicle!) {
          hideVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public setVehicleControlZoneId<T = any>(
    command: SetVehicleControlZoneId,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'SetVehicleControlZoneId',
      SetVehicleControlZoneIdMutation,
      SetVehicleControlZoneIdMutationVariables,
      T
    >({
      name: 'SetVehicleControlZoneId',
      mutation: gql`
        mutation SetVehicleControlZoneIdMutation($command: SetVehicleControlZoneId!) {
          setVehicleControlZoneId(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public undeleteVehicle<T = any>(
    command: UndeleteVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UndeleteVehicle',
      UndeleteVehicleMutation,
      UndeleteVehicleMutationVariables,
      T
    >({
      name: 'UndeleteVehicle',
      mutation: gql`
        mutation UndeleteVehicleMutation($command: UndeleteVehicle!) {
          undeleteVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public unhideVehicle<T = any>(
    command: UnhideVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UnhideVehicle',
      UnhideVehicleMutation,
      UnhideVehicleMutationVariables,
      T
    >({
      name: 'UnhideVehicle',
      mutation: gql`
        mutation UnhideVehicleMutation($command: UnhideVehicle!) {
          unhideVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateVehicle<T = any>(
    command: UpdateVehicle,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateVehicle',
      UpdateVehicleMutation,
      UpdateVehicleMutationVariables,
      T
    >({
      name: 'UpdateVehicle',
      mutation: gql`
        mutation UpdateVehicleMutation($command: UpdateVehicle!) {
          updateVehicle(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  // VehicleStateInspections
  public addVehicleStateInspection<T = any>(
    command: AddVehicleStateInspection,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'AddVehicleStateInspection',
      AddVehicleStateInspectionMutation,
      AddVehicleStateInspectionMutationVariables,
      T
    >({
      name: 'AddVehicleStateInspection',
      mutation: gql`
        mutation AddVehicleStateInspectionMutation($command: AddVehicleStateInspection!) {
          addVehicleStateInspection(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public deleteVehicleStateInspection<T = any>(
    command: DeleteVehicleStateInspection,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'DeleteVehicleStateInspection',
      DeleteVehicleStateInspectionMutation,
      DeleteVehicleStateInspectionMutationVariables,
      T
    >({
      name: 'DeleteVehicleStateInspection',
      mutation: gql`
        mutation DeleteVehicleStateInspectionMutation($command: DeleteVehicleStateInspection!) {
          deleteVehicleStateInspection(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
  public updateVehicleStateInspection<T = any>(
    command: UpdateVehicleStateInspection,
    options: GraphQLMutationExecutionOptions,
  ): Observable<CommandResult<T>> {
    return this._executor.execute<
      'UpdateVehicleStateInspection',
      UpdateVehicleStateInspectionMutation,
      UpdateVehicleStateInspectionMutationVariables,
      T
    >({
      name: 'UpdateVehicleStateInspection',
      mutation: gql`
        mutation UpdateVehicleStateInspectionMutation($command: UpdateVehicleStateInspection!) {
          updateVehicleStateInspection(command: $command) {
            status
            data
            command
            emittedEvents
            entities
            errors {
              message
              code
            }
          }
        }
      `,
      variables: { command },
      options,
    });
  }
}
